import { Injectable } from '@angular/core';
import { AlertController, LoadingController } from '@ionic/angular';
import {HttpClient, HttpErrorResponse , HttpHeaders ,HttpParams } from '@angular/common/http';

import { Observable } from "rxjs";
import {  throwError } from 'rxjs';
import { retry, catchError, delay } from 'rxjs/operators';
import { ThrowStmt } from '@angular/compiler';
import { getMaxListeners } from 'process';
import { DomSanitizer } from '@angular/platform-browser';

import * as AWS from 'aws-sdk';
import * as S3 from 'aws-sdk/clients/s3';

import * as FileSaver from 'file-saver';
import { saveAs } from 'file-saver';
import { base64StringToBlob } from 'blob-util'


import { Router, ActivatedRoute } from '@angular/router';
import { HostListener } from '@angular/core';
import { LocationStrategy } from '@angular/common';

const uuidv1 = require('uuid/v1');
@Injectable({
  providedIn: 'root'
})
export class RemoteService {

  // femsUrl : string =  "https://cors-anywhere.herokuapp.com/" + "https://api.protoexpress-api.net/kidev/quote";
  femsUrl : string = "https://api.protoexpress-api.net/kidev";
  // femsshipping : string = "https://staging.app.protoexpress.com";
  femsshipping : string = "https://qakicad.app.protoexpress.com";
  AppBaseURL : string = "https://qakicad.app.protoexpress.com";
  AppLocationBaseURL : string = "https://api.protoexpress-api.net/dev";
  // femsUserUrl: string = "https://scastaging.app.protoexpress.com:8073";
  // AppBaseURL : string = "https://api.allorigins.win/get?url=" + "https://staging.protoexpress.com/sierra-app";
  // AppBaseURL : string = "http://alloworigin.com/get?url=" + "https://staging.protoexpress.com/sierra-app";
  // femsOrderDetailsApi: string = "https://34.205.54.220:8080/orderapi/order/orderdata";
  // BaseEmptyPemntUrl  : string = "https://862ly8jnhi.execute-api.us-east-1.amazonaws.com/Dev";
  public RedirectAppBaseUrl:string = "https://staging.protoexpress.com/";
  public TermsURL : string = "https://www.protoexpress.com/terms-and-conditions/";
  bomProcessUrl : string = "https://scastaging.app.protoexpress.com";
  GetLocationUrl:string = "https://scastaging.app.protoexpress.com/bom";

  public access_token: any;
  public access_token_response: any;

  public kicad_uid:string;
  public kicad_uuid:any;
  public kicad_wmqid:string;
  public kicad_accessToken:string;
  public kicad_refreshToken:string;
  public kicad_selectedQuantity:string;
  public kicad_selectedTurntime:string;
  public kicad_selectedQuantityRequot:string;
  public kicad_selectedTurntimeRequot:string;
  public entireJson:string;

  public user:any;
  public sca_init_quote_cache:any;
  public sca_quoteRequestJSON:any;
  public sca_quoteResponsePriceMatrixJSON:any;
  public mat2d:any;
  public mattp:any;
  public usr_sel_unitPrice:any;
  public usr_TestingPrice:any;
  public usr_TestingPriceFlag:any;
  public showUnitPrice:boolean = false;
  public wqid_Obj:any;
  public femsFalseSubmit;
  public femsTrueSubmit;
  public imagePath;

  // sreedhar
  public alladdress:any;
  public tempShippingCost:string = "0.00";
  public shippingCost:string = "0.00";
  public designFile:any;
  public default_add_payment:any;
  public notificationData:any;
  public notofiListFname:any;
  public notofiListLName:any;
  public notofiListEmail:any;
  public notofiListPhone:any;
  public notofiListPrimary:any;
  public notofiListDesigner:any;
  public notofiListBilling:any;
  public notofiListShipping:any;
  public notofiListEngineer:any;
  public notofiListQualityCtrl:any;
  public notofiListTwentyFourHrs:any;
  public notofiListShareProject:any;
  public notificationList:any;
  public new_accessToken:string;
  public taxInformation:any;
  public resaleInformation:any;
  public taxableRate:any;
  public taxablePrice:string = "0.00";
  public resaleNum:any;
  public validatedAddress:any;
  public contact_state_code:any;
  public state_name:any;
  public state_code:any;
  public orderID:any;
  public defaultCountry:any;
  public defaultState:any;
  public defaultCity:any;
  public addressBtnText:any;
  public orderTotal:any;
  public addressTypeIdMultiple:any;
  public bomData:any;
  public bomFileName:any;
  public eDataIte:any;
  public eDataFet:any;
  public assemblyQty:any;
  public assemblyTurnTime:any;
  public AssemblyUnitPrice:any;
  public assemblyTaxPrice:any;
  public componentTaxPrice:any;
  public assemblySides:any;
  public customBomFileName;
  public primaryCheckCount:any = {};
  public numItemsCharging:any;
  public wqNumForLog:any;
  public logincheck:boolean=false;
  public loginOrderData:{};
  public isGuestGlobal:any;
  public loginAccessToken:any;
  public clientID:any;
  public guestEmail:any;
  public pcbPromoDiscount:any;
  public assemblyPromoDiscount:any;
  public componentPromoDiscount:any;
  public totalPromoDiscountAmount:any;
  public promoCode:any;
  public pcbAssemblyPromo : boolean = false;
  public pendingPaymentMessage:any='';
  public pendingPaymentObj:any = {}
  // sreedhar

  // sivaji
  public cardType:any;
  public cardHolderName: string;
  public cardNumber: string;
  public cardExpiryDate:any;
  public cardCvvNumber:any;
  public cardId:any;

  public creditCardInfo:any;
  public selectedCreditCard:any;
  public creditCardEditPopup: boolean = false;
  public shippingAddressPopup: boolean = false;
  public billingAddressPopup: boolean = false;
  public designerAddressPopup: boolean = false;
  public selectedShippingAddress: any;
  public selectedBillingAddress: any;
  public selectedDesignerAddress: any;
  public taxable: boolean = false;
  public resaleNumber: any = "";
  public taxExemptCertiNumber:any = "";
  public taxExemptOutsideCalifornia:any = "";
  public shippingAccountNumber:any;
  public shippingNotes:any;
  public partData:any;
  public partDataJson:any;
  public quoteItems:any;
  public wqId:any;
  public projectID:any;
  public uploadedFile:any;
  public fullFile:any;
  public s3FileName:any;
  public PictureName:any;
  public addressBookName:any;
  public addressAction:any;
  // sivaji

  // jansi
  public address_type_id:any;
  public address_id:any;
  public contact_first_name:string;
  public contact_last_name:string;
  public contact_address1:any;
  public contact_address2:any;
  public contact_city:any;
  public contact_country:any;
  public contact_state:any;
  public contact_zipcode:any;
  public contact_phone:any;
  public contact_fax:any;
  public addAddressResponse:any;
  public country_list:any;
  public state_list:any;
  public city_list:any;
  public countryListJson:any;
  public default_add_address:any;
  public add_to_all_address:any;
  public contact_user_id:any;
  public contact_email:any;
  public contact_company:any;
  public updateAddressResponse:any;
  public addressEditPopup: boolean = false;
  public selectedShipingCountry:any;
  public selectedShipingState:any;
  public selectedShipingCity:any;
  public shippingOptionResponse = [];
  public shippingMethod:any;
  public defaultAddressData:any;
  public mark_default_address:any;
  public defaultCreditCard:any;
  public customBomFile:boolean = false;
  public typeOfBomFile:any;
  public onlyPcb:boolean= true;
  public isCookiePopupShown: boolean = true ;
  public supported_quantiy_for_selected_turntime = new Map();
  public isNotAuthChecked : boolean = false;
  public purchasingPersonDetails:any = {};
  public billingAddressSelected:any = {};
  public orderRedirectUrl:any
  // jansi

   // Rajesh
  public kicad_selectedETesting:any = 'Yes';
  public kicad_selectedETestingRequot:any = 'Yes';
  public quoteLayer: any;
  public quoteStandardJson: any;
  public bomItems: any;
  public kicad_totalCostCompAssembly:any;
  public kicad_pcbPartDataSpecs:any;
  // public bomUploadFileName: any;
  // Rajesh


  //private access_token_headers:string = "{ 'Authorization': 'Basic 037c5c10-916b-11e8-a9a3-6710a465c191' , 'Content-Type':'application/json' , 'Accept':'application/json' }";  
  private access_token_body_auth_id = "037c5c10-916b-11e8-a9a3-6710a465c191";
  private access_token_body_client_id = "037c5c10-916b-11e8-a9a3-6710a465c191";
  private access_token_body_username = "siva.3516.10@gmail.com";
  private access_token_body_password = "password";

  private access_token_body = "";

  // private newaccess_token_body_username = "rhinosource";
  // private newaccess_token_body_password = "Sierr@rhino123";
  private newaccess_token_body_username = "KiCAD";
  private newaccess_token_body_password = "53A97D2E6318761A7ACB5DC09AA03B0E";
  // private newaccess_token_body_username = "KiCAD";
  // private newaccess_token_body_password = "Sierr@kicad123";
 
  
  openCheck = false;
  initialPrecheck = false;
  public contactPersonName24hrs:any;
  public contactPersonPhone24hrs:any;
  public partNo:any;
  public revision:any;
  public registeredUserCheck:any;
  constructor(private httpClient: HttpClient, public alertController: AlertController, public _DomSanitizationService: DomSanitizer, public loadingController:LoadingController,
    private location: LocationStrategy,
    private router : Router) { 
    console.log("clientID",uuidv1())
    this.clientID = uuidv1();
  }

  backButtonAlert(){
    this.openCheck = false;
    history.pushState({}, null, window.location.href);
    this.location.onPopState(() => {
      history.pushState({}, null, window.location.href);
      if(!this.openCheck){
        this.presentAlertConfirm();
      }
    });
  }

  
  async presentAlertConfirm() {
    this.openCheck = true;
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Alert!',
      message: 'Refreshing or navigating back will result in the loss of data',
      backdropDismiss:false,
      buttons: [
        {
          text: 'Ok',
          // role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            // console.log('Confirm Cancel: blah');
            this.router.navigateByUrl('/data-lost');
          }
        }, {
          text: 'Cancel',
          cssClass: 'danger delete-address',
          handler: () => {
            this.openCheck = false;
            console.log('Confirm Okay');
          }
        }
      ]
    });

    await alert.present();
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    console.log('Back button pressed');
    event.preventDefault();
    this.presentAlertConfirm();
  }

  handleError(error: HttpErrorResponse) {
    let errorMessage = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }

  // getAccessToken() {
  //   if ( this.access_token_response==null 
  //     || this.access_token_response==undefined
  //     || this.access_token_response=="") {

  //     this.access_token_body = " { \"client_id\": \""+this.access_token_body_client_id+"\", \"username\": \""+this.access_token_body_username+"\", \"password\": \""+this.access_token_body_password+"\" }  ";
    

  //       var headers = new  HttpHeaders().set("Authorization", "Basic " + this.access_token_body_auth_id);

  //       var options = { headers: headers};

  //       return this.httpClient.post<any>( this.BaseAuthorizationApiUrl
  //                                       , this.access_token_body
  //                                       , options
  //                                       ).subscribe((data: any[])=>{
  //                                         this.access_token_response = data;

  //                                         console.log("accesstoken", this.access_token_response.access_token);
  //                                       });

  //     } else {
        
  //     }
  // }
  
  async alertCall(subMessage,message){
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      subHeader: subMessage,
      backdropDismiss: false,
      message: message,
      buttons: ['OK']
    });
    await alert.present();
  }
  
  getQuoteDataService(uuId){
    var headers = new HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
                      let params = new HttpParams().set("uuid", uuId);
          return new Promise((resolve,reject)=>{
            this.httpClient.get<any>( this.AppBaseURL + "/store"
            // this.httpClient.get<any>( "https://staging.app.protoexpress.com/store"
            , {headers: headers, params:params}
            ).subscribe(resData => {
              if(resData.data == null){
                this.alertCall('',"Something went wrong");
              }
              return resolve(resData);
            }, error => {
              this.alertCall('',"Something went wrong");
              return resolve(error);
              console.log(error);
            }); 
          })
  }
  getSessionDataService(userId,AccessTckn){
    var headers = new HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" )
                      .set("session", this.kicad_uuid);
      let params = new HttpParams()
        .set('userID', userId);
        // KIP-1362
        // .set('accessToken', AccessTckn)
        return new Promise((resolve,reject)=>{
          // KIP-1362
          // return this.httpClient.get<any>( "https://2nf3mfbvtb.execute-api.us-east-1.amazonaws.com/stage/kicad-session", {headers: headers, params:params}
          return this.httpClient.get<any>( this.AppBaseURL+"/sessionEncrypt", {headers: headers, params:params}
                ).subscribe((sessionData)=>{
                  return resolve(sessionData);
                }, (error: any[])=>{
                  return resolve(error);
                  console.log(error);
                });
              })
  }
  newAccessToken() {
      console.log("New access token called")
      // const headers = {
      //   'Authorization': 'Basic c2llcnJhLWNsaWVudDpzaWVycmEtc2VjcmV0',
      //   'Content-type': 'application/x-www-form-urlencoded',
      //   "Access-Control-Allow-Origin": "*",
      //   "Access-Control-Allow-Methods": "POST" ,
      //   "Access-Control-Allow-Headers": "X-Requested-With"
      // }
      var headers = new HttpHeaders().set("Authorization", "Basic c2llcnJhLWNsaWVudDpzaWVycmEtc2VjcmV0" )
                      .set("Content-Type", "application/x-www-form-urlencoded" )
                      .set("Accept", "application/json" )
                      .set("Access-Control-Allow-Origin", "*" )
                      .set("Access-Control-Allow-Methods", "GET" )
                      .set("Access-Control-Allow-Methods", "PUT" )
                      .set("Access-Control-Allow-Methods", "POST" )
                      .set("Access-Control-Allow-Methods", "DELETE" )
                      .set("Access-Control-Allow-Methods", "OPTIONS" )
                      .set("Access-Control-Allow-Methods", "POST" )
                      .set("Access-Control-Allow-Headers", "X-Requested-With" );

      const body = new HttpParams()
        .set('username', this.newaccess_token_body_username)
        .set('password', this.newaccess_token_body_password)
        .set('grant_type', 'password');

      return this.httpClient.post<any>( this.AppBaseURL + "/oauth/token"
                                      , body
                                      , {headers}
                                      ).subscribe((data)=>{
                                        //console.log("NEW ACCESS TOKEN", data);
                                        console.log(data);
                                        this.new_accessToken = data.access_token;
                                        console.log("access token generated.......", this.new_accessToken)
                                        //console.log("this.new_accessToken",this.new_accessToken);
                                      }, (error: any[])=>{
                                        console.log(error);
                                      });
  }
  
  getUserProfileBy_KicadUser(){
    // if(this.isGuestGlobal == false || this.isGuestGlobal == "False"){
    //   var headers = new  HttpHeaders().set("Authorization", "Bearer " + this.kicad_accessToken);
    // }else if(this.isGuestGlobal=="noGuestKey"){
    //   var headers = new  HttpHeaders().set("Authorization", "Bearer " + this.kicad_accessToken);
    // }else{
    //   var headers = new  HttpHeaders().set("Authorization", "Bearer " + this.loginAccessToken);
    // }
  var headers = new  HttpHeaders().set("Accept", "application/json" )
                                  .set("session", this.kicad_uuid );
    let params = new HttpParams().set("user_id", this.kicad_uid);
    this.httpClient.get<any>(this.AppBaseURL + "/profile"
      , {headers: headers, params:params}
      ).subscribe((data: any[])=>{
        this.user = data;
        console.log(this.user);
      }, (error: any[])=>{
        console.log(error);

      });

  }

  getImageFile(){
    var headers = new  HttpHeaders().set("Authorization", this.kicad_accessToken)
                                    .set("user_id", this.kicad_uid);

    let params = new HttpParams().set("service", "getFileBase64")
                                  .set("fileName", this.PictureName);
    this.httpClient.get<any>(this.AppBaseURL + "/superAPI"
    // this.httpClient.get<any>("https://staging.app.protoexpress.com/superAPI"
      , {headers: headers, params:params}
      ).subscribe((data: any[])=>{
        this.imagePath = 'data:image/jpg;base64,' + (this._DomSanitizationService.bypassSecurityTrustResourceUrl(data['body'].slice(2,-1)) as any).changingThisBreaksApplicationSecurity;
      }, (error: any[])=>{
        console.log("Error while get image", error);
        this.imagePath = "assets/img/pcblive.png"
      });
  }
//Commented based on KIP-943-------------------------*
  getBOMFile(filename){
    console.log("this.customBomFileName",this.customBomFileName);
    console.log("this.designFile",this.designFile);
    console.log("filename",filename);
    let fileExtension = filename.substr(filename.length - 3);
    var headers = new  HttpHeaders().set("Authorization", this.kicad_accessToken)
                                    .set("user_id", this.kicad_uid);
    let params = new HttpParams().set("service", "getFileBase64")
                                  .set("fileName", filename);
    this.httpClient.get<any>(this.AppBaseURL + "/superAPI"
    // this.httpClient.get<any>("https://staging.app.protoexpress.com/superAPI"
      , {headers: headers, params:params}
      ).subscribe((data: any[])=>{
        //this.bomData = 'data:application/csv;base64,' + (this._DomSanitizationService.bypassSecurityTrustResourceUrl(data['body'].slice(2,-1)) as any).changingThisBreaksApplicationSecurity;
        this.bomData = (this._DomSanitizationService.bypassSecurityTrustResourceUrl(data['body'].slice(2,-1)) as any).changingThisBreaksApplicationSecurity;
        //console.log("BOM",this.bomData,filename);
        
        if(fileExtension == "xls"){
          let contentType='text/xls';
          let blob = base64StringToBlob(this.bomData, contentType);
          if(this.customBomFile == true){
            saveAs(blob, this.customBomFileName+"_BOM.xls",{ autoBOM: true });
          }else{
            saveAs(blob, this.designFile+"_BOM.xls",{ autoBOM: true });
          }
          
        }else{
          let contentType='text/csv';
          let blob = base64StringToBlob(this.bomData, contentType);
          if(this.customBomFile == true){
            saveAs(blob, this.customBomFileName+"_BOM.csv",{ autoBOM: true });
          }else{
            saveAs(blob, this.designFile+"_BOM.csv",{ autoBOM: true });
          }
          
        }
        
      }, (error: any[])=>{
        console.log("Error While Get BOM File", error);
        //this.imagePath = "assets/img/pcblive.png"
      });
  }

  get_Sca_order_quote_cache(){
      this.sca_quoteResponsePriceMatrixJSON = this.entireJson;
        // this.sca_quoteResponsePriceMatrixJSON = JSON.parse(this.sca_init_quote_cache.quoteResponsePriceMatrixJSON);

        // this.usr_TestingPriceFlag = this.sca_quoteRequestJSON.electricalTesting; 
      var a2d = "[";
      var wqm = this.sca_quoteResponsePriceMatrixJSON.webQuoteMatrix;
      var pi = 0;
        for (var i = 0; i < wqm.length; i++) { 

            if ( i == 0 ){

              pi = wqm[i].quantity;
              
              a2d += "{";
              a2d += "\"qty\":\""+wqm[i].quantity+"\" , "; 
              a2d += "\"tp\": [";
              a2d += "\""+wqm[i].turntime+"~"+wqm[i].unitPrice+"~"+wqm[i].testingPrice+"~"+wqm[i].isCallUs+"\"  "; 
            } else {
                if ( wqm[i].quantity == pi){
                  a2d += ", \""+wqm[i].turntime+"~"+wqm[i].unitPrice+"~"+wqm[i].testingPrice+"~"+wqm[i].isCallUs+"\"  "; 
                } else {
                  a2d += "] },";

                  
                  a2d += "{";
                  a2d += "\"qty\":\""+wqm[i].quantity+"\" , "; 
                  a2d += "\"tp\": ["; 
                  a2d += "\""+wqm[i].turntime+"~"+wqm[i].unitPrice+"~"+wqm[i].testingPrice+"~"+wqm[i].isCallUs+"\"  "; 
                  pi = wqm[i].quantity;
                }
            }
        }
        
        if ( a2d.length> 0 ) a2d += "] }";
        a2d += "]"; 
        
        this.mat2d = JSON.parse(a2d);
        //console.log("this.mat2d",this.mat2d);
        for (var i = 0; i < this.mat2d.length; i++) {
          var individual_mat_obj = this.mat2d[i]
          for (var j = 0; j < individual_mat_obj.tp.length; j++) 
          {
            var tp_array = individual_mat_obj.tp[j].split("~");
            var turnTime = tp_array[0];
            var not_call_us = tp_array[3] == "0";
            if(not_call_us)
            {
                var quantity=[];
                // add keyvalue pair (turntime, quatity_array) if turntime is not present
                if(!this.supported_quantiy_for_selected_turntime.has(turnTime))
                {
                this.supported_quantiy_for_selected_turntime.set(turnTime, quantity)
                }

                // populate the quantity array
                if(this.supported_quantiy_for_selected_turntime.get(turnTime).indexOf(individual_mat_obj.qty) == -1)
                {
                  this.supported_quantiy_for_selected_turntime.get(turnTime).push(individual_mat_obj.qty);
                }
            }
            
          }
        }
        //console.log("supported_quantiy_for_selected_turntime",this.supported_quantiy_for_selected_turntime)
        if ( this.mat2d!="" && this.mat2d!=null && this.kicad_selectedQuantity!="" && this.kicad_selectedQuantity!=null)
        {
          var q;
          for (var j = 0; j < this.mat2d.length; j++) {
            if ( this.mat2d[j].qty == this.kicad_selectedQuantity){
                this.mattp =  this.mat2d[j].tp ; 
            }
          }
          
          var r;
          if ( this.mattp!=null )
          {
            for (var j = 0; j < this.mattp.length; j++) {
              r = this.mattp[j].split("~");
              if( r[0] == this.kicad_selectedTurntime)
              {
                this.usr_sel_unitPrice = r[1];
                this.showUnitPrice = true;
                if ( this.usr_TestingPriceFlag!=null && this.usr_TestingPriceFlag!="False")
                {
                  this.usr_TestingPrice = r[2];
                }
                else
                {
                  this.usr_TestingPrice = "0";
                }
              }
            }
            
          }
        }
        
    
    this.showUnitPrice = false;

  }
  // postCreditcardInfo(){
  //   var headers = new  HttpHeaders().set("Content-Type", "application/json" );
  //   var postData = {"name": this.cardHolderName,
  //                   "typeid": this.cardType, "cardnumber": this.cardNumber,
  //                   "cvv": this.cardCvvNumber, "expirydate": this.cardExpiryDate};
  //   var options = { headers: headers};
  //   this.httpClient.post<any>( this.BaseEmptyPemntUrl, {MYRESULTS:postData}, options
  //                   ).subscribe(data => {
  //                     console.log(data);
  //                     var newCardData = data;
  //                     var cardArray = new Array();
  //                     cardArray.push({
  //                       name       : newCardData.name,
  //                       cardtype   : newCardData.creditCardName,
  //                       cardnumber : newCardData.cardnumber,
  //                       expirydate : newCardData.expirydate,
  //                       cvv        : newCardData.cvv,
  //                       id         : "1",
  //                       typeid     : newCardData.typeid
  //                     });
  //                     if(cardArray[0].default == true){
  //                       this.selectedCreditCard=cardArray[0];
  //                     }
  //                    }, error => {
  //                     console.log(error);
  //                   });
  // }

  // getCreditCardInfo(){
  //   var headers = new  HttpHeaders().set("Content-Type", "application/json" );

  //   var credit_card_details = [{name : "John", default : false, cardtype : "Visa",
  //                               cardnumber : "6123456789654123", expirydate : "12/12", cvv : '111',
  //                               id : "1", typeid : "1"
  //   }]
  //   this.httpClient.post<any>(this.BaseEmptyPemntUrl, {MYRESULTS:credit_card_details},
  //                     {headers: headers}
  //                     ).subscribe((data: any[])=>{
  //                       var lis = new Array()
  //                       var firstData = new Array();
  //                       for (var i = 0; i < data.length; i++) {
  //                         lis.push({name:data[i].name,
  //                                               default:data[i].default,
  //                                               cardtype:data[i].cardtype,
  //                                               cardnumber:data[i].cardnumber,
  //                                               expirydate:data[i].expirydate,
  //                                               cvv:data[i].cvv,
  //                                               id:data[i].id,
  //                                               typeid:data[i].typeid
  //                         })
  //                       }
  //                       this.creditCardInfo = lis;
  //                       // for(var i=0; i < this.creditCardInfo.length;i++){
  //                       //   if(this.creditCardInfo[i].default == true){
  //                       //     firstData.push({
  //                       //       name       : this.creditCardInfo[i].name,
  //                       //       default    : this.creditCardInfo[i].default,
  //                       //       cardtype   : this.creditCardInfo[i].cardtype,
  //                       //       cardnumber : this.creditCardInfo[i].cardnumber,
  //                       //       expirydate : this.creditCardInfo[i].expirydate,
  //                       //       cvv        : this.creditCardInfo[i].cvv,
  //                       //       id         : this.creditCardInfo[i].id,
  //                       //       typeid     : this.creditCardInfo[i].typeid
  //                       //     });
  //                       //     this.selectedCreditCard=firstData[0];
                            
  //                       //     this.creditCardInfo[i].name = this.creditCardInfo[0].name;
  //                       //     this.creditCardInfo[i].default = this.creditCardInfo[0].default;
  //                       //     this.creditCardInfo[i].cardtype = this.creditCardInfo[0].cardtype;
  //                       //     this.creditCardInfo[i].cardnumber = this.creditCardInfo[0].cardnumber;
  //                       //     this.creditCardInfo[i].expirydate = this.creditCardInfo[0].expirydate;
  //                       //     this.creditCardInfo[i].cvv = this.creditCardInfo[0].cvv;
  //                       //     this.creditCardInfo[i].id = this.creditCardInfo[0].id;
  //                       //     this.creditCardInfo[i].typeid = this.creditCardInfo[0].typeid;

  //                       //     this.creditCardInfo[0].name = firstData[0].name;
  //                       //     this.creditCardInfo[0].default = firstData[0].default;
  //                       //     this.creditCardInfo[0].cardtype = firstData[0].cardtype;
  //                       //     this.creditCardInfo[0].cardnumber = firstData[0].cardnumber;
  //                       //     this.creditCardInfo[0].expirydate = firstData[0].expirydate;
  //                       //     this.creditCardInfo[0].cvv = firstData[0].cvv;
  //                       //     this.creditCardInfo[0].id = firstData[0].id;
  //                       //     this.creditCardInfo[0].typeid = firstData[0].typeid;
  //                       //     console.log("this.selectedCreditCard2",this.selectedCreditCard);
  //                       //   }
  //                       // }
  //                     }, (error: any[])=>{
  //                         console.log(error);
  //                     });
  // }

  // getOrderDetails(){
  //   var headers = new  HttpHeaders().set("access-token", "123")
  //                     .set("Content-Type", "application/json" )
  //                     .set("Accept", "application/json" );


  //   var params = {wqID:this.wqId}
  //   this.httpClient.get<any>(this.femsOrderDetailsApi+'/userID='+this.kicad_uid, {headers:headers, params:params}
  //                     ).subscribe(data =>{
  //                       console.log("Place order data");
  //                       console.log(data);
  //                     }, error =>{
  //                       console.log('error found while get order data', error);
  //                     });

  // }
  getOrderdata(){
    this.showLoader();
    var headers = new  HttpHeaders().set("access-token", "123")
                      .set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
    
    // assembly_quantity, assembly_turntime should use once assembly implemented
    // var params = {user_id:this.kicad_uid, wmq_id:this.kicad_wmqid, pcb_quantity:this.kicad_selectedQuantity, pcb_turntime:this.kicad_selectedTurntime}
    var params = {user_id:this.kicad_uid, wmq_id:this.kicad_wmqid, pcb_quantity:this.kicad_selectedQuantity, pcb_turntime:this.kicad_selectedTurntime,assembly_quantity:this.assemblyQty?this.assemblyQty:null,assembly_turntime:this.assemblyTurnTime?this.assemblyTurnTime:null}
    
    console.log("params", params)
    return new Promise((resolve,reject)=>{
                          // this.getOrderInputDetails();
    this.httpClient.get<any>(this.femsUrl + "/quote/getorderdata", {headers:headers, params:params}
                      ).subscribe(data =>{
                        this.hideLoader();
                        console.log("get order data....................................");
                        console.log(data);
                        if ('partdata' in data){
                          this.partData = JSON.stringify(data.partdata).slice(1, -1).replace(/"/g, ' ').replace(/,/g, ', ');
                          this.partDataJson = data.partdata;
                          this.quoteItems = data.quoteItems
                          this.wqId = data.wqID
                          this.projectID = data.projectID
                          // this.getOrderDetails()
                          this.getOrderInputDetails();
                          // this.getShippingOptions('');
                        }
                        return resolve(data);
                      }, error =>{
                        this.hideLoader();
                        console.log('error found while get order data', error);
                        this.quoteItems = [];
                        if (error.error) {
                          this.alertCall('',error.error.split(',')[0].split(':')[0] +'.<br><br>'+ error.error.split(',')[0].split(':')[2]);
                        }
                        return resolve(error);
                      });
                    });
  }

  set_Dummy_WQID(){
    this.wqid_Obj ={"success":true,"message":{"minHoleSize":"0.006 inches","wqID":"WQ45441-5A","edgePlating":"No","counterSink":"No","electricalTesting":"No","partRevision":"1","solderMaskType":"LPI","surfaceFinish":"HASL","quoteFooterList":["**NRE done, but charges are waived","**No Electrical Testing","**<a href='https://www.protoexpress.com/webproduct/showShippingOption.jsp' target='_blank'>Shipping</a> & Taxes extra as applicable","**IMPORTANT: Please read Terms and Conditions for our quote and order at <a href='www.protoexpress.com/terms' target='_blank'>www.protoexpress.com/terms</a> In particular, review the section on Web PCB/Assembly or Turnkey Pro as appropriate. Quote line item for components will only be valid for 7 days from date of quote. After that we reserve the right to re-quote."],"routeAndRetain":"No","solderMask":"Yes","minimumSpaceInnerLyr":"0.004 Inches","layers":"4","silkScreenColor":"Black","controlledDielectric":"No","arrayYDim":"1.5","urlRedirect":"https://staging.protoexpress.com/webproductUploadFileRedirect.jsp?data=Dt30MudDwtw4cR5TrIRxNUI3civD%2BgtVd27uK%2Bo1Xn5HdAawz06iVfSZCDB6hcp16sTUm3lgtcv5DXe4OivYzCZv%2Fp044NljM%2F1D66npVFE%3D","projectID":"SCA0001","indBoardXDim":"4","quoteItems":[{"partNo":"SCA_Quote_Test_30","partRevNo":"1","quoteItemType":"PCB","webQuoteItemNo":"WQ45441-5A1","quantity":"20","turntime":"5","unitPrice":"42.4700","boardPrice":"849.40","electricalTestingPrice":"140.00","subTotal":"849.4"}],"scoring":"No","silkScreenSides":"Top","roHSMarking":"LPI","goldFingers":"No","grandTotal":"849.40","minimumSpace":"0.006 inches","solderMaskFinish":"Standard (Semi-Gloss)","vendorMarking":"Yes","itar":"No","noOfHolesPerBoard":"25","outerLyrFinishCopper":"1 Oz","solderMaskColor":"Green","silkScreen":"Yes","material":"FR4","finishedThickness":"0.062 inches","boardsPerArray":"2","partNumber":"SCA_Quote_Test_30","arrays":"Yes","arrayXDim":"10","indBoardYDim":"2.25","counterBore":"No","memberID":"ssdctmp_sreedharm@protoexpress.com"},"additionalData":null,"errors":null};
  }
  fileChange(event) {
    let fileList: FileList = event.target.files;
    if(fileList.length > 0) {
        const file: File = fileList[0];
        const formData:FormData = new FormData();
        formData.append('file', file);
        console.log("filename", formData)
        this.uploadedFile = formData
        // let headers = new Headers();
        // headers.append('Content-Type', 'multipart/form-data');
        // headers.append('Accept', 'application/json');
        // //let options = new RequestOptions({ headers: headers });
        // this.httpClient.post('', formData);
    }
  }

  // Show the loader for infinite time
  showLoader() {
    this.loadingController.create({
      message: 'Please wait...'
    }).then((res) => {
      res.present();
    });
  }

  hideLoader() {
    this.loadingController.dismiss().then((res) => {
      console.log('Loading dismissed!', res);
    }).catch((error) => {
      console.log('error', error);
    });
  }
  placeOrder(router){
    var creditCardDetails = {
        // "creditCardExpirationDate":!this.isNotAuthChecked? this.selectedCreditCard.expirydate:'',
        "creditCardHolderName": !this.isNotAuthChecked ? this.selectedCreditCard.name:'',
        // "creditCardNumber": !this.isNotAuthChecked ? this.selectedCreditCard.cardnumber:'',
        // "creditCardSecurityCode":!this.isNotAuthChecked ? this.selectedCreditCard.cvv:'',
        // "creditCardType":!this.isNotAuthChecked ? this.selectedCreditCard.cardtype:''
    }
    var placeOrder = {
      "areComponentCanNotWashed": "",
      "billingAddressLine1": this.selectedBillingAddress.addressLine1,
      "billingAddressLine2": this.selectedBillingAddress.addressLine2,
      "billingCity": this.selectedBillingAddress.city,
      "billingContactCompany": this.selectedBillingAddress.companyName,
      "billingContactEmail": this.selectedBillingAddress.email,
      "billingContactFirstName":this.selectedBillingAddress.firstName,
      "billingContactLastName":this.selectedBillingAddress.lastName,
      "billingContactPhone": this.selectedBillingAddress.phoneNumber,
      "billingCountry":this.selectedBillingAddress.country,
      "billingState": this.selectedBillingAddress.state,
      "billingZip":this.selectedBillingAddress.zip,
      "bomSpecialInstructions": "No",
      "channelOrderNumber": "401",
      "contactPersonName24Hour": '',
      "contactPhoneNumber24Hour": '',
      // KIP-1439 
      // "contactPersonName24Hour": this.contactPersonName24hrs?this.contactPersonName24hrs:'',
      // "contactPhoneNumber24Hour": this.contactPersonPhone24hrs?this.contactPersonPhone24hrs:'',
      //"customerEmail": "contactperson@gmail.com",
      //KIP-1436 this.resaleNumber == undefined ? "":this.resaleNumber,
      "customerEmail":this.user != null? this.user.registrationEmail:"",
      "designFileName": this.designFile.split('\\')[this.designFile.split('\\').length - 1],
      "designerAddressLine1": this.selectedDesignerAddress.addressLine1,
      "designerAddressLine2": this.selectedDesignerAddress.addressLine2,
      "designerCity": this.selectedDesignerAddress.city,
      "designerContactCompany":this.selectedDesignerAddress.companyName,
      "designerContactEmail": this.selectedDesignerAddress.email,
      "designerContactFirstName": this.selectedDesignerAddress.firstName,
      "designerContactLastName":this.selectedDesignerAddress.lastName,
      "designerContactPhone": this.selectedDesignerAddress.phoneNumber,
      "designerCountry":this.selectedDesignerAddress.country,
      "designerState": this.selectedDesignerAddress.state,
      "designerZip": this.selectedDesignerAddress.zip,
      "isElectricalTest": this.usr_TestingPriceFlag == "False" ? "N": "Y",
      "iwillSupplyPcbAs": "0",
      "pcbComingFrom": "0",
      "pcbReceiveDate": "",
      "projectID": "KICAD0001",
      "promoCode": this.promoCode != '' ? this.promoCode:"",
      "referencePONumber": "",
      "resaleFileByteArray": "",
      "resaleFileName": "",
      "resaleNumber":this.isNotAuthChecked ?'': this.resaleNumber == undefined ? "":this.resaleNumber,
      "shipAssembledBoard": "",
      "shippingAccountNumber": this.shippingAccountNumber == undefined ? "":this.shippingAccountNumber,
      "shippingAddressLine1":this.selectedShippingAddress.addressLine1,
      "shippingAddressLine2": this.selectedShippingAddress.addressLine2,
      "shippingCity": this.selectedShippingAddress.city,
      "shippingContactCompany": this.selectedShippingAddress.companyName,
      "shippingContactEmail": this.selectedShippingAddress.email,
      "shippingContactFirstName": this.selectedShippingAddress.firstName,
      "shippingContactLastName": this.selectedShippingAddress.lastName,
      "shippingContactPhone": this.selectedShippingAddress.phoneNumber,
      "shippingCountry":this.selectedShippingAddress.country,
      "shippingState": this.selectedShippingAddress.state,
      "shippingZip": this.selectedShippingAddress.zip,
      "shippingMethod": this.shippingMethod,
      "shippingNotes": this.shippingNotes?this.shippingNotes:'',
      "taxable": this.isNotAuthChecked ? '': this.taxable ? "1":"0",
      "taxExemptCertNumber":this.isNotAuthChecked ? '': this.taxExemptCertiNumber,
      "taxExemptOutsideCalifornia":this.isNotAuthChecked ? '': this.taxExemptOutsideCalifornia,
      "sierraPCBToolNo": "",
      "specifyWhichCompCanNotWashed": "No",
      "whenComponentWillArrive": ""
    };
    var purchasingPersonDetails = {
      "paymentPending" : this.purchasingPersonDetails.paymentPending == true?'1':"0",
      "firstName": this.isNotAuthChecked?this.purchasingPersonDetails.firstName:'',
      "lastName": this.isNotAuthChecked?this.purchasingPersonDetails.lastName:'',
      "email": this.isNotAuthChecked?this.purchasingPersonDetails.email:'',
      "remark": this.isNotAuthChecked?this.purchasingPersonDetails.remarks:'NA',
    };
    if ( placeOrder!=null ){
      this.showLoader();
      var headers = new  HttpHeaders().set("Authorization", "bearer ")
                                      .set("session", this.kicad_uuid );
      let params:any; //new HttpParams().set("submitToFems", "true" );
      params = new HttpParams().set("userId", this.kicad_uid )
                              .set("wqnumber", this.wqId)
                              .set("userToken", this.kicad_accessToken)
                              .set("placeOrder", JSON.stringify(placeOrder))
                              .set("creditCardDetails", JSON.stringify(creditCardDetails))
                              .set("purchasingPersonDetails", JSON.stringify(purchasingPersonDetails))
                              .set("fileName", this.s3FileName);
      var options = { headers: headers , params: params};
      var place_order_body = {
        userId: this.kicad_uid,
        userToken: this.kicad_accessToken,
        placeOrder: placeOrder,
        creditCardDetails: creditCardDetails,
        purchasingPersonDetails: purchasingPersonDetails,
        wqnumber: this.wqId,
        fileName: this.s3FileName
      }
      console.log("place order bosy is", place_order_body);
      this.httpClient.post<any>( this.AppBaseURL + "/subOrder", place_order_body, options
      // this.httpClient.post<any>( "https://staging.app.protoexpress.com/subOrder", place_order_body, options
      ).subscribe(data => {
        this.hideLoader();
        if(!data.msg || data.msg != 'Access denied'){
          if(!data.errorMessage){
            this.orderID  = data.orderNumber;
            if(data.orderNumber){
              router.navigateByUrl('/my-orders/payment-success');
              this.femsTrueSubmit = {
                "orderNumber": data.orderNumber,
                "orderSubTotal": data.orderSubTotal,
                "shippingCharges": data.shippingCharges,
                "calculatedTax": data.calculatedTax,
                "orderTotal": data.orderTotal,
                "promisedShipDate": data.promisedShipDate,
                "quantity" : this.quoteItems.length>0?this.quoteItems[0].quantity:'',
                "turntime" : this.quoteItems.length>0?this.quoteItems[0].turntime+' day(s)':'',
                "partNo" : this.quoteItems.length>0?this.quoteItems[0].partNo:'',
                "partRevNo" : this.quoteItems.length>0?this.quoteItems[0].partRevNo:'',
                "pendingPaymentMessage" : data.pendingPaymentMessage
              };
              return data
            }
          }else{
            return this.alertCall('Alert',data.errorMessage);
          }
        }else{
          this.router.navigateByUrl('/session-timeout-model');
        }
        // console.log("place order DATA", data);
      },error =>{
        this.hideLoader();
        console.log('Error in place order api', error); 
        return this.alertCall('Alert',error);

      });
                                        

    }
  }
  public placeOrderVfp(placeOrderData:any) : Observable<any>{
    var placeOrder = {
      "areComponentCanNotWashed": "",
      "billingAddressLine1": this.selectedBillingAddress.addressLine1,
      "billingAddressLine2": this.selectedBillingAddress.addressLine2,
      "billingCity": this.selectedBillingAddress.city,
      "billingContactCompany": this.selectedBillingAddress.companyName,
      "billingContactEmail": this.selectedBillingAddress.email,
      "billingContactFirstName":this.selectedBillingAddress.firstName,
      "billingContactLastName":this.selectedBillingAddress.lastName,
      "billingContactPhone": this.selectedBillingAddress.phoneNumber,
      "billingCountry":this.selectedBillingAddress.country,
      "billingState": this.selectedBillingAddress.state,
      "billingZip":this.selectedBillingAddress.zip,
      "bomSpecialInstructions": "No",
      "channelOrderNumber": "401",
      "contactPersonName24Hour": '',
      "contactPhoneNumber24Hour": '',
      // KIP-1439 
      // "contactPersonName24Hour": this.contactPersonName24hrs?this.contactPersonName24hrs:'',
      // "contactPhoneNumber24Hour": this.contactPersonPhone24hrs?this.contactPersonPhone24hrs:'',
      //"customerEmail": "contactperson@gmail.com",
      //KIP-1436 this.resaleNumber == undefined ? "":this.resaleNumber,
      "customerEmail":this.user != null? this.user.registrationEmail:"",
      "designFileName": this.designFile.split('\\')[this.designFile.split('\\').length - 1],
      "designerAddressLine1": this.selectedDesignerAddress.addressLine1,
      "designerAddressLine2": this.selectedDesignerAddress.addressLine2,
      "designerCity": this.selectedDesignerAddress.city,
      "designerContactCompany":this.selectedDesignerAddress.companyName,
      "designerContactEmail": this.selectedDesignerAddress.email,
      "designerContactFirstName": this.selectedDesignerAddress.firstName,
      "designerContactLastName":this.selectedDesignerAddress.lastName,
      "designerContactPhone": this.selectedDesignerAddress.phoneNumber,
      "designerCountry":this.selectedDesignerAddress.country,
      "designerState": this.selectedDesignerAddress.state,
      "designerZip": this.selectedDesignerAddress.zip,
      "isElectricalTest": this.usr_TestingPriceFlag == "False" ? "N": "Y",
      "iwillSupplyPcbAs": "0",
      "pcbComingFrom": "0",
      "pcbReceiveDate": "",
      "projectID": "KICAD0001",
      "promoCode": this.promoCode != '' ? this.promoCode:"",
      "referencePONumber": "",
      "resaleFileByteArray": "",
      "resaleFileName": "",
      "resaleNumber":this.isNotAuthChecked ?'': this.resaleNumber == undefined ? "":this.resaleNumber,
      "shipAssembledBoard": "",
      "shippingAccountNumber": this.shippingAccountNumber == undefined ? "":this.shippingAccountNumber,
      "shippingAddressLine1":this.selectedShippingAddress.addressLine1,
      "shippingAddressLine2": this.selectedShippingAddress.addressLine2,
      "shippingCity": this.selectedShippingAddress.city,
      "shippingContactCompany": this.selectedShippingAddress.companyName,
      "shippingContactEmail": this.selectedShippingAddress.email,
      "shippingContactFirstName": this.selectedShippingAddress.firstName,
      "shippingContactLastName": this.selectedShippingAddress.lastName,
      "shippingContactPhone": this.selectedShippingAddress.phoneNumber,
      "shippingCountry":this.selectedShippingAddress.country,
      "shippingState": this.selectedShippingAddress.state,
      "shippingZip": this.selectedShippingAddress.zip,
      "shippingMethod": this.shippingMethod,
      "shippingNotes": this.shippingNotes?this.shippingNotes:'',
      "taxable": this.isNotAuthChecked ? '': this.taxable ? "1":"0",
      "taxExemptCertNumber":this.isNotAuthChecked ? '': this.taxExemptCertiNumber,
      "taxExemptOutsideCalifornia":this.isNotAuthChecked ? '': this.taxExemptOutsideCalifornia,
      "sierraPCBToolNo": "",
      "specifyWhichCompCanNotWashed": "No",
      "whenComponentWillArrive": ""
    };
    var purchasingPersonDetails = {
      "paymentPending" : this.purchasingPersonDetails.paymentPending == true?'1':"0",
      "firstName": this.isNotAuthChecked?this.purchasingPersonDetails.firstName:'',
      "lastName": this.isNotAuthChecked?this.purchasingPersonDetails.lastName:'',
      "email": this.isNotAuthChecked?this.purchasingPersonDetails.email:'',
      "remark": this.isNotAuthChecked?this.purchasingPersonDetails.remarks:'NA',
    };
    var creditCardDetails = {
      "creditCardHolderName": !this.isNotAuthChecked ? this.cardHolderName:'',
    }
    let params:any;
    if ( placeOrder!=null ){
      this.showLoader();
      var headers = new  HttpHeaders().set("Authorization", "bearer ")
                                    .set("session", this.kicad_uuid );
      params = new HttpParams().set("userId", this.kicad_uid )
                              .set("wqnumber", this.wqId)
                              .set("userToken", this.kicad_accessToken)
                              .set("placeOrder", JSON.stringify(placeOrder))
                              .set("creditCardDetails", JSON.stringify(creditCardDetails))
                              .set("purchasingPersonDetails", JSON.stringify(purchasingPersonDetails))
                              .set("fileName", this.s3FileName);
      var options = { headers: headers , params: params};
      var place_order_body = {
        userId: this.kicad_uid,
        userToken: this.kicad_accessToken,
        placeOrder: placeOrder,
        creditCardDetails: creditCardDetails,
        purchasingPersonDetails: purchasingPersonDetails,
        wqnumber: this.wqId,
        fileName: this.s3FileName
      }
      return this.httpClient.post(this.AppBaseURL + "/subOrder", place_order_body,options);
    }
  }

  addressValidation(addressId){
    var headers = new HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
    let params = new HttpParams().set("address1", this.contact_address1)
                      .set("city", this.contact_city)
                      .set("state", this.state_list[this.contact_state])
                      .set("zip", this.contact_zipcode);
                      //console.log(this.contact_address1, this.contact_city,this.contact_state,this.contact_zipcode);
    return new Promise((resolve,reject)=>{
                    this.httpClient.get<any>( this.AppLocationBaseURL+"/address-validation"
                      , {headers: headers, params:params}
                      ).subscribe(data =>{
                        if (data == null) {
                          this.addressValidation(addressId);
                          return
                        }
                        this.validatedAddress = data.results[0][0][0];
                        var validadd1 = data.results[0][0][0][1];
                        var validcity = data.results[0][0][0][9];
                        var validstate = data.results[0][0][0][10];
                        var validzip = data.results[0][0][0][12];
                        data.addrValidation = true;
                        //console.log("this.validatedAddress", this.validatedAddress);
                        console.log(validadd1, validcity, validstate, validzip);
                        
                        if(validadd1 == "No Match Found" || validcity == "No Match Found" || validstate == "No Match Found" || validzip == "No Match Found"){
                          window.alert("Please fill the valid address, address validation failed");
                          data.addrValidation = false;
                          return resolve(data);
                        }
                        if(this.contact_address1 != validadd1 || this.contact_city != validcity || this.contact_state != validstate || this.contact_zipcode != validzip){
                          
                          if (!addressId) {
                            this.contact_address1 = validadd1;
                            this.contact_city = validcity ;    
                            // this.contact_state=validstate ;   
                            this.contact_zipcode = validzip;
                          }

                          if (addressId) {
                            this.addressEditPopup = false;
                          }
                          //Based on the button text validation the address is it Post or Put
                          if(this.addressBtnText =="Save"){
                            //this.address_id = addressId;
                            //console.log("validated editaddress", this.address_id);
                            this.updateAddressDetails(addressId);
                          }else{
                            //console.log("validated add address");
                            this.addNewAddress(addressId);
                          }
                          //this.addNewAddress(addressId);
                          //alert("post called");
                          resolve(data);
                        }else{
                          if(this.addressBtnText =="Save"){
                            //console.log("correct editaddress");
                            this.updateAddressDetails(addressId);
                          }else{
                            //console.log("correct add address");
                            this.addNewAddress(addressId);
                          }
                          resolve(data);
                        }
                        // return 
                      },error=>{
                        return resolve(error);
                        console.log(error);
                      });      
    })
  }
  
  getAddressBookData(){
    this.showLoader();
    //window.alert("do you want to delete the address");
    var headers = new  HttpHeaders()
                      .set("Content-Type", "application/json" )
                      .set("Accept", "application/json" )
                      .set("session", this.kicad_uuid);
                      // .set("Authorization", "Bearer " + this.new_accessToken)

          let params = new HttpParams().set("userID", this.kicad_uid);
          return new Promise((resolve,reject)=>{
            this.httpClient.get<any>( this.AppBaseURL +"/getaddressbookdetails"
            , {headers: headers, params:params}
            ).subscribe(data => {
              this.hideLoader();
              this.resaleInformation = data.resaleNumber;
              this.resaleNumber = data.resaleNumber
              // this.contactPersonName24hrs = data.contactName24Hour
              // this.contactPersonPhone24hrs = data.contactPhoneNumber24Hour
              console.log(data);
              return resolve(data);
            }, error => {
              this.hideLoader();
              console.log(error);
              return resolve(error);
            }); 
          })
  }
  
  deleteAddress(addressId){
    var addressID = addressId;
    console.log("deleteing address id", addressId);
    //window.alert("do you want to delete the address");
    var headers = new  HttpHeaders()
                      .set("Content-Type", "application/json" )
                      .set("Accept", "application/json" )
                      .set("session", this.kicad_uuid);
                      // .set("Authorization", "Bearer " + this.new_accessToken);

    let params = new HttpParams().set("userID", this.kicad_uid)
                                 .set("addressId", addressID);
          return new Promise((resolve,reject)=>{
            this.httpClient.delete<any>( this.AppBaseURL +"/address"
            , {headers: headers, params:params}
            ).subscribe(data => {
              if(!data.msg || data.msg != 'Access denied'){
                console.log(data);
                return resolve(data);
              }else{
                this.router.navigateByUrl('/session-timeout-model');
              }
            }, error => {
              return resolve(error);
              console.log(error);
            }); 
          })
  }

  addNewAddress(addressId){
    this.address_id = addressId;
    this.address_type_id = addressId;
    if(this.shippingAddressPopup){
      this.address_type_id = '3'
    }
    if (this.billingAddressPopup){
      this.address_type_id = '2'
    }
    if (this.designerAddressPopup){
      this.address_type_id = '1'
    }
    if(this.add_to_all_address){
      this.address_type_id = addressId;
    }
    //console.log(this.address_type_id );
    var headers = new HttpHeaders().set("Content-Type", "application/json")
                                   .set("Accept", "application/json")
                                  //  .set("Authorization", "Bearer "+ this.new_accessToken)
                                   .set("session", this.kicad_uuid);
                                  //  .set("Cookie","JSESSIONID=95F3BE0B1A2CFCFE1DF5BFF1B549C03E");
    var params = {userID:this.kicad_uid}                               
    //let params = new HttpParams().set("userID", this.kicad_uid);
               
    var options = { headers: headers , params: params};

    var address_data_body = {"addressType":this.address_type_id, "firstname":this.contact_first_name,
                            "lastname":this.contact_last_name, "email":this.contact_email, "phone":this.contact_phone,"fax":this.contact_fax,
                            "address1": this.contact_address1 , "address2" : this.contact_address2,
                            "city":this.contact_city ,"country":this.contact_country, "state":this.contact_state,
                            "zip":this.contact_zipcode,"defaultForType":this.default_add_address,"company":this.contact_company};
    console.log("addressbody", address_data_body);
    return this.httpClient.post<any>( this.AppBaseURL + "/address"
                        ,address_data_body
                        ,{headers: headers, params: params}
                        ).subscribe(data => {
                          if(!data.msg || data.msg != 'Access denied'){
                            var newAddress = address_data_body;
                            console.log("postaddress", data);
                            var newAddressList = new Array();
                            newAddressList.push({
                              firstName        :newAddress.firstname,
                              lastName         :newAddress.lastname,
                              company          :newAddress.company,
                              addressLine1     :newAddress.address1,
                              addressLine2     :newAddress.address2,
                              city             :newAddress.city,
                              state            :newAddress.state,
                              country          :newAddress.country,
                              zip              :newAddress.zip,
                              phoneNumber      :newAddress.phone,
                              fax              :newAddress.fax,
                              default          :newAddress.defaultForType,
                              //addressId        :newAddress.addressId,
                              addressTypeId    :newAddress.addressType,
                              email            :newAddress.email
                            });
                            console.log("postaddress1", newAddressList);
                            // if(newAddressList[0].default){
                            if(newAddressList[0].default == 1){
                              if(newAddressList[0].addressTypeId == 3 ){
                                this.selectedShippingAddress=newAddressList[0];
                              }
                              if(newAddressList[0].addressTypeId == 2){
                                this.selectedBillingAddress=newAddressList[0];
                                this.billingAddressSelected = newAddressList[0];
                              }
                              if(newAddressList[0].addressTypeId == 1 ){
                                this.selectedDesignerAddress=newAddressList[0];
                              }
                            }
                          }else{
                            this.router.navigateByUrl('/session-timeout-model');
                          }
                        },error=>{
                          console.log(error);
                          window.alert("failed to add address");
                          if(this.address_type_id == 3 ){
                            this.selectedShippingAddress = {};
                          }
                          if(this.address_type_id == 2){
                            this.selectedBillingAddress = {};
                          }
                          if(this.address_type_id == 1 ){
                            this.selectedDesignerAddress = {};
                          }
                        });

  }


  getCountryList(){
    var headers = new HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
    
    this.httpClient.get<any>( this.GetLocationUrl+"/country"
                      , {headers: headers}
                      ).subscribe(data =>{
                        this.country_list = data;
                        this.defaultCountry = this.country_list[216];
                        console.log("default country>>", this.defaultCountry);
                        //console.log(this.country_list[216]);
                      },error=>{
                        console.log(error);
                      });
  }

  getStateByCountry(){
    var headers = new HttpHeaders().set("Content-Type", "application/json")
                      .set("Accept", "application/json" );
    let params = new HttpParams().set("country", "United States");
                      
    this.httpClient.get<any>( this.GetLocationUrl+"/state"
                      , {headers: headers, params: params}
                      ).subscribe(data =>{
                        this.state_list = data;
                        this.state_name = Object.keys(data);
                        this.state_code = Object.values(data);
                        // this.defaultState = data.California;
                        // for(var ds in data){
                        //   if (data['CA']=='California') {
                            this.defaultState = 'California';
                        //   }
                        // }
                        console.log("STATELISTDATA",data.Alabama);
                        console.log("default state>>",this.defaultState);
                        
                        //console.log("onlykeys", Object.keys(data));
                      },error=>{
                        console.log(error);
                      });
  }
  getCityByState(){
    var headers = new HttpHeaders().set("Content-Type", "application/json")
                      .set("Accept", "application/json" );
    let params = new HttpParams().set("state", "California");
                      
    this.httpClient.get<any>( this.GetLocationUrl+"/city"
                      , {headers: headers, params: params}
                      ).subscribe(data =>{
                        this.city_list = data;
                        this.defaultCity = this.city_list[989]
                        console.log("default city>>", this.defaultCity);
                      },error=>{
                        console.log(error);
                      });
  }

  updateAddressDetails(addressId){
    this.address_id = addressId;
    console.log("AD ID", addressId);
    var headers = new HttpHeaders()
                                  .set("Content-Type", "application/json" )
                                  .set("Accept", "application/json" )
                                  .set("session", this.kicad_uuid);
                                  // .set("Authorization" , "Bearer "+this.new_accessToken)

    var params = {userID:this.kicad_uid} 
    //this.address_type_id
    var default_add = this.default_add_address == true ? "1":"0";
    var update_address_body = {"addressType":this.address_type_id,"addressid":this.address_id, "firstname":this.contact_first_name,
                                "lastname":this.contact_last_name, "email":this.contact_email, "phone":this.contact_phone,"fax":this.contact_fax,
                                "address1": this.contact_address1 , "address2" : this.contact_address2,
                                "city":this.contact_city ,"country":this.contact_country, "state":this.contact_state,
                                "zip":this.contact_zipcode,"defaultForType":default_add,"company":this.contact_company};
    console.log("update_address_body",update_address_body); 
    
    return this.httpClient.put<any>( this.AppBaseURL + "/address"
                        ,update_address_body
                        ,{headers: headers, params:params }
                        ).subscribe(data => {
                          if(!data.msg || data.msg != 'Access denied'){
                            var updatedAddress       = data;
                            var updatedAddressList = new Array();
                            updatedAddressList.push({
                              firstName        :updatedAddress.firstname,
                              lastName         :updatedAddress.lastname,
                              addressLine1     :updatedAddress.address1,
                              addressLine2     :updatedAddress.address2,
                              city             :updatedAddress.city,
                              state            :updatedAddress.state,
                              country          :updatedAddress.country,
                              zip              :updatedAddress.zip,
                              phoneNumber      :updatedAddress.phone,
                              fax              :updatedAddress.fax, 
                              default          :updatedAddress.defaultForType,
                              addressId        :updatedAddress.addressid,
                              addressTypeId    :updatedAddress.addressType,
                              email            :updatedAddress.email,
                              companyName      :updatedAddress.company
                            });
                            // if(updatedAddressList[0].default){
                            if(parseFloat(updatedAddressList[0].default) == 1){
                              if(updatedAddressList[0].addressTypeId == 3 ){
                                this.selectedShippingAddress=updatedAddressList[0];
                              }
                              if(updatedAddressList[0].addressTypeId == 2){
                                this.selectedBillingAddress=updatedAddressList[0];
                              }
                              if(updatedAddressList[0].addressTypeId == 1 ){
                                this.selectedDesignerAddress=updatedAddressList[0];
                              }
                            }
                          }else{
                            this.router.navigateByUrl('/session-timeout-model');
                          }
                        },error=>{
                          console.log(error);
                        });

  }

  getAddressDetails(addressview){
    var address_type = ''
    this.alladdress = [];
    // if(this.shippingAddressPopup){
    //   address_type = '3'
    // }
    // if (this.billingAddressPopup){
    //   address_type = '2'
    // }
    // if (this.designerAddressPopup){
    //   address_type = '1'
    // }
    var headers = new  HttpHeaders()
                      .set("Content-Type", "application/json" )
                      .set("Accept", "application/json" )
                      .set("session", this.kicad_uuid);
                      // .set("Authorization", "Bearer "+ this.new_accessToken)
    var params = {userID:this.kicad_uid}
    //let params = new HttpParams().set("userID", "00c82b43-6fb5-4e2f-9488-0d8c1c107a98");  
    return new Promise((resolve,reject)=>{
    this.httpClient.get<any>( this.AppBaseURL+"/address"
      , {headers: headers, params: params}
      ).subscribe(data => {
        if(!data.msg || data.msg != 'Access denied'){
            // for(var i=0 ; i < data.length; i++){
            //   //Based On KIP-1300 added this condition START
            //   if(data[i].address1 == 'Your Address' || (data[i].firstname == 'Assembly' || data[i].lastname == 'Receiving')){
            //     data.splice(i,1);
            //     // break;
            //     // delete data[i]
            //   }
            // }
            data = data.filter(list => {
              if(list.address1 == 'Your Address' || (list.firstname == 'Assembly' || list.lastname == 'Receiving')){
                return false
              }
              return true
            });
            //KIP-1300 END list.address1 != 'Your Address' || (list.firstname != 'Assembly' || list.lastname != 'Receiving')
            //console.log("getaddress data",data);
            var addressListArray = new Array();
            var first = new Array();
            var addresses        = data;
            // if (addressview == 'list') {
            //   this.selectedBillingAddress = {};
            //   this.selectedShippingAddress = {};
            //   this.selectedDesignerAddress = {};
            // }
            for(var i=0 ; i < addresses.length; i++){
              // if(address_type == addresses[i].addressType){
                if (i==0 && addressview == 'list') {
                  this.selectedBillingAddress = {};
                  this.selectedShippingAddress = {};
                  this.selectedDesignerAddress = {};
                }
                addressListArray.push({
                  firstName           :addresses[i].firstname,
                  lastName            :addresses[i].lastname,
                  addressLine1        :addresses[i].address1,
                  addressLine2        :addresses[i].address2,
                  city                :addresses[i].city,
                  state               :addresses[i].state,
                  country             :addresses[i].country,
                  zip                 :addresses[i].zip,
                  phoneNumber         :addresses[i].phone,
                  fax                 :addresses[i].fax,
                  default             :addresses[i].defaultForType,
                  //scaUserId         :addresses[i].scaUserId,
                  addressId           :addresses[i].addressid,
                  // addressTypeId       :addresses[i].addressType,
                  email               :addresses[i].email,
                  companyName         :addresses[i].company,
                  isDefaultForBilling :addresses[i].isDefaultForBilling,
                  isDefaultForDesign  :addresses[i].isDefaultForDesign,
                  isDefaultForShipping:addresses[i].isDefaultForShipping
                })
                if (addressview == 'list') {

                  if (addresses[i].isDefaultForShipping == '1' || addresses[i].isDefaultForShipping == 1) {
                    this.selectedShippingAddress = addressListArray[i];
                  }

                  if (addresses[i].isDefaultForDesign == '1' || addresses[i].isDefaultForDesign == 1) {
                    this.selectedDesignerAddress = addressListArray[i];
                  }

                  if (addresses[i].isDefaultForBilling == '1' || addresses[i].isDefaultForBilling == 1) {
                    this.selectedBillingAddress = addressListArray[i];
                  }

                }
            }
            this.alladdress = addressListArray;
            // console.log(addressListArray);
            // for(var i=0 ; i < this.alladdress.length; i++){
              // if(this.alladdress[i].default == 1){
              //   first.push({
              //     firstName          :this.alladdress[i].firstName,
              //     lastName           :this.alladdress[i].lastName,
              //       addressLine1     :this.alladdress[i].addressLine1,
              //       addressLine2     :this.alladdress[i].addressLine2,
              //       city             :this.alladdress[i].city,
              //       state            :this.alladdress[i].state,
              //       country          :this.alladdress[i].country,
              //       zip              :this.alladdress[i].zip,
              //       phoneNumber      :this.alladdress[i].phoneNumber,
              //       default          :this.alladdress[i].default,
              //       //scaUserId        :this.alladdress[i].scaUserId,
              //       addressId        :this.alladdress[i].addressId,
              //       addressTypeId    :this.alladdress[i].addressTypeId,
              //       email            :this.alladdress[i].email,
              //       companyName      :this.alladdress[i].companyName
              //   });

              //     this.alladdress[i].firstName = this.alladdress[0].firstName;
              //     this.alladdress[i].lastName = this.alladdress[0].lastName;
              //     this.alladdress[i].addressLine1 = this.alladdress[0].addressLine1;
              //     this.alladdress[i].addressLine2 = this.alladdress[0].addressLine2;
              //     this.alladdress[i].city = this.alladdress[0].city ;  
              //     this.alladdress[i].state = this.alladdress[0].state;
              //     this.alladdress[i].country = this.alladdress[0].country ;
              //     this.alladdress[i].zip = this.alladdress[0].zip;
              //     this.alladdress[i].phoneNumber = this.alladdress[0].phoneNumber;
              //     this.alladdress[i].default = this.alladdress[0].default;
              //     //this.alladdress[i].scaUserId = this.alladdress[0].scaUserId ;
              //     this.alladdress[i].addressId = this.alladdress[0].addressId;
              //     this.alladdress[i].addressTypeId = this.alladdress[0].addressTypeId;
              //     this.alladdress[i].email = this.alladdress[0].email;
              //     this.alladdress[i].companyName = this.alladdress[0].companyName;
          
              //     this.alladdress[0].firstName = first[0].firstName;
              //     this.alladdress[0].lastName = first[0].lastName;
              //     this.alladdress[0].addressLine1 = first[0].addressLine1;
              //     this.alladdress[0].addressLine2 = first[0].addressLine2;
              //     this.alladdress[0].city = first[0].city ;  
              //     this.alladdress[0].state = first[0].state;
              //     this.alladdress[0].country = first[0].country ;
              //     this.alladdress[0].zip = first[0].zip;
              //     this.alladdress[0].phoneNumber = first[0].phoneNumber;
              //     this.alladdress[0].default = first[0].default;
              //     //this.alladdress[0].scaUserId = first[0].scaUserId ;
              //     this.alladdress[0].addressId = first[0].addressId;
              //     this.alladdress[0].addressTypeId = first[0].addressTypeId;
              //     this.alladdress[0].email = first[0].email;
              //     this.alladdress[0].companyName = first[0].companyName;
                
              // }
            // }
            return resolve(data);
          }else{
            this.router.navigateByUrl('/session-timeout-model');
          }
       }, error => {
        return resolve(error);
        console.log(error);
      });
    }) 
  }

  getShippingOptions(loadType){
    this.showLoader();
    var headers = new  HttpHeaders()
    // .set("access-token", "123")"b55ebbf4-ea04-3c50-a8b0-dd7980f0bee3"
                      .set("Content-Type", "application/json" )
                      .set("Accept", "application/json" )
                      .set("session", this.kicad_uuid);
                      // .set("Authorization", "Bearer "+ this.new_accessToken);

    let params = new HttpParams().set("userID", this.kicad_uid)
                                .set("ShippingCountry", this.selectedShippingAddress.country)
                                .set("ShippingState", this.selectedShippingAddress.state)
                                .set("ShippingZip", this.selectedShippingAddress.zip)
                                .set("wqnumber", this.wqId);
    return new Promise((resolve,reject)=>{
    if (this.wqId && this.selectedShippingAddress.country) {

    this.httpClient.get<any>(this.AppBaseURL + "/getshippingoptions"
    // this.httpClient.get<any>(this.femsshipping + "/shippingOptions"
                      , {headers: headers, params: params}
                      ).subscribe(data => {
                        this.hideLoader();
                        if(!data.msg || data.msg != 'Access denied'){
                          console.log(data);
                          var shippingOptionArray = new Array();
                          var shipping        = data.shippingItems;
                          if (shipping) {
                            for(var i = 0; i < shipping.length; i++){
                              shippingOptionArray.push({
                                 shippingID      : shipping[i].shippingID,
                                 shippingOption  : shipping[i].shippingOption,
                                 shippingPrice   : shipping[i].shippingPrice
                                })
                            }
                          }
                          // this.shippingOptionResponse = shippingOptionArray;
                          return resolve(shippingOptionArray);
                        }else{
                          this.router.navigateByUrl('/session-timeout-model');
                        }
                       }, error => {
                        this.hideLoader();
                        return resolve(error);
                        console.log(error);
                      }) 
    }else{
      return resolve([]);
    }
                    });

  }

  getDefaultAddress(addressType){
    var address_type = ''
    if (addressType == "designer"){
      address_type = '1'
    }
    if (addressType == "billing"){
      address_type = '2'
    }
    if(addressType == "shipping"){
      address_type = '3'
    }
    
    var headers = new  HttpHeaders()
                      .set("Content-Type", "application/json" )
                      .set("Accept", "application/json" )
                      .set("session", this.kicad_uuid);
                      // .set("Authorization", "Bearer "+ this.new_accessToken)
    var params = {userID:this.kicad_uid}
    //let params = new HttpParams().set("userID", "00c82b43-6fb5-4e2f-9488-0d8c1c107a98");  
    return new Promise((resolve,reject)=>{
    this.httpClient.get<any>( this.AppBaseURL+"/address"
      , {headers: headers, params: params}
      ).subscribe(data => {
        if(!data.msg || data.msg != 'Access denied'){
          var addressListArray = new Array();
          var first = new Array();
          var addresses        = data;
          for(var i=0 ; i < addresses.length; i++){
            if(address_type == addresses[i].addressType){
              addressListArray.push({
                addressId     :addresses[i].addressid,
                addressTypeId :addresses[i].addressType,
                default       :addresses[i].defaultForType,
                companyName   :addresses[i].company,
                firstName     :addresses[i].firstname,
                lastName      :addresses[i].lastname,
                email         :addresses[i].email,
                addressLine1  :addresses[i].address1,
                addressLine2  :addresses[i].address2,
                city          :addresses[i].city,
                state         :addresses[i].state,
                country       :addresses[i].country,
                zip           :addresses[i].zip,
                phoneNumber   :addresses[i].phone,
                fax           :addresses[i].fax
              })
              
            }
          }
          for(var i=0 ; i < addressListArray.length; i++){
            if(addressListArray[i].default == "1"){
              first.push({
                  firstName        :addressListArray[i].firstName,
                  lastName         :addressListArray[i].lastName,
                  addressLine1     :addressListArray[i].addressLine1,
                  addressLine2     :addressListArray[i].addressLine2,
                  city             :addressListArray[i].city,
                  state            :addressListArray[i].state,
                  country          :addressListArray[i].country,
                  zip              :addressListArray[i].zip,
                  phoneNumber      :addressListArray[i].phoneNumber,
                  default          :addressListArray[i].default,
                  addressId        :addressListArray[i].addressId,
                  addressTypeId    :addressListArray[i].addressTypeId,
                  email            :addressListArray[i].email,
                  companyName      :addressListArray[i].companyName
              });
            }
          }
          if (addressListArray.length && !first.length){
            first.push({
              firstName        :addressListArray[0].firstName,
              lastName         :addressListArray[0].lastName,
              addressLine1     :addressListArray[0].addressLine1,
              addressLine2     :addressListArray[0].addressLine2,
              city             :addressListArray[0].city,
              state            :addressListArray[0].state,
              country          :addressListArray[0].country,
              zip              :addressListArray[0].zip,
              phoneNumber      :addressListArray[0].phoneNumber,
              default          :addressListArray[0].default,
              addressId        :addressListArray[0].addressId,
              addressTypeId    :addressListArray[0].addressTypeId,
              email            :addressListArray[0].email,
              companyName      :addressListArray[0].companyName
          });
          }
          if(addressType == "shipping"){
            this.selectedShippingAddress=first[0];
            if (first.length==0) {
              this.selectedShippingAddress = {};
            }
          }
          if (addressType == "billing"){
            this.selectedBillingAddress=first[0];
            if (first.length==0) {
              this.selectedBillingAddress = {};
            }
          }
          if (addressType == "designer"){
            this.selectedDesignerAddress=first[0];
            if (first.length==0) {
              this.selectedDesignerAddress = {};
            }
          }
          return resolve(data)
        }else{
          this.router.navigateByUrl('/session-timeout-model');
        }
      }, error => {
        console.log(error);
        return resolve(error)
      });

      })

  }
  //Notification list start
  //get Notification list
  getNotificationData(){
    var headers = new  HttpHeaders()
                      .set("Content-Type", "application/json" )
                      .set("Accept", "application/json" )
                      .set("session", this.kicad_uuid);
                      // .set("Authorization", "bearer "+this.new_accessToken)
    
    var params = {userID:this.kicad_uid, ordernumber:this.orderID}
    this.httpClient.get<any>(this.AppBaseURL + "/notifications", {headers:headers, params:params}
                      ).subscribe(data =>{
                        if(data.msg == 'Access denied'){
                          this.router.navigateByUrl('/session-timeout-model');
                        }else{
                          this.primaryCheckCount['trueCount'] = 0;
                          // console.log("get Notification data");
                          // console.log(data);  

                          var NotificationListArray = new Array();
                          var notification        = data;
                          for(var i = 0; i < notification.length; i++){
                            if(notification[i].roles.primary == "1"){
                              this.primaryCheckCount['trueCount'] += 1;
                            }
                            NotificationListArray.push({
                              firstNmae    : notification[i].firstNmae,
                              lastName     : notification[i].lastName,
                              email        : notification[i].email,
                              phone        : notification[i].phone,
                              dnd          : notification[i].dnd == "1" ? true:false,
                              primary      : notification[i].roles.primary == "1" ? true:false,
                              designer     : notification[i].roles.designer == "1" ? true:false,
                              billing      : notification[i].roles.billing == "1" ? true:false,
                              shipping     : notification[i].roles.shipping == "1" ? true:false,
                              engineer     : notification[i].roles.engineer == "1" ? true:false,
                              qualityCtrl  : notification[i].roles.qualityCtrl == "1" ? true:false,
                              twentyFourHrs: notification[i].roles.twentyFourHrs == "1" ? true:false,
                              shareProject : notification[i].roles.shareProject == "1" ? true:false,
                              })
                          }
                          this.notificationData = NotificationListArray;
                          console.log("Re-arranged Notification Data", this.notificationData);
                        }
                      }, error =>{
                        console.log('error found while get Notifiction data', error);
                      });
  }

  //Update Notification list
  updateNotificationDetails(){
    var headers = new HttpHeaders()
                                  .set("Content-Type", "application/json" )
                                  .set("Accept", "application/json" )
                                  .set("session", this.kicad_uuid);
                                  // .set("Authorization" , "bearer "+this.new_accessToken)
    var params = {userID:this.kicad_uid, orderId:this.orderID}
    
    let notificationList=[];
    for(var k=0;k<this.notificationData.length;k++){
      notificationList.push({
          "firstNmae": this.notificationData[k].firstNmae,
          "lastName": this.notificationData[k].lastName,
          "email": this.notificationData[k].email,
          "phone": this.notificationData[k].phone,
          "dnd": this.notificationData[k].dnd == false ? "0" : "1",
        "roles": {
          "primary": this.notificationData[k].primary == false ? "0" : "1",
          "designer": this.notificationData[k].designer == false ? "0" : "1",
          "billing": this.notificationData[k].billing == false ? "0" : "1",
          "shipping": this.notificationData[k].shipping == false ? "0" : "1",
          "engineer": this.notificationData[k].engineer == false ? "0" : "1",
          "qualityCtrl": this.notificationData[k].qualityCtrl == false ? "0" : "1",
          "twentyFourHrs": this.notificationData[k].twentyFourHrs == false ? "0" : "1",
          "shareProject": this.notificationData[k].shareProject == false ? "0" : "1"
        }
      });
    }
    
    var update_notification_body ={notificationList:notificationList}
    //console.log(update_notification_body);
    return this.httpClient.put<any>( this.AppBaseURL + "/notifications"
                        ,update_notification_body
                        ,{headers: headers, params:params}
                        ).subscribe(data => {
                          if(data.msg == 'Access denied'){
                            this.router.navigateByUrl('/session-timeout-model');
                          }else{
                            var updateNotificationList     = data;
                            //console.log("nnnnnnn", data);
                            this.alertCall('',"Notification details updated");
                            //alert("Notification Details Updated");
                            console.log("updatedNotificationData", updateNotificationList);
                            // var updatedNotifyList = new Array();
                            // for(var i = 0; i < updateNotificationList.length; i++){
                            //   updatedNotifyList.push({
                            //     firstName        :updateNotificationList.firstNmae,
                            //     lastName         :updateNotificationList.lastName,
                            //     Email            :updateNotificationList.email,
                            //     phone            :updateNotificationList.phone,
                            //     primary          :updateNotificationList.roles.primary,
                            //     designer         :updateNotificationList.roles.designer,
                            //     billing          :updateNotificationList.roles.billing,
                            //     shipping         :updateNotificationList.roles.shipping,
                            //     engineer         :updateNotificationList.roles.engineer,
                            //     qualityCtrl      :updateNotificationList.roles.qualityCtrl,
                            //     twentyFourHrs    :updateNotificationList.roles.twentyFourHrs,
                            //     shareProject     :updateNotificationList.roles.shareProject
                            //   });
                            // }
                          }
                          
                        },error=>{
                          console.log(error);
                          var errstr = "";
                          for(var err in error.error.fieldErrors[0]){
                            errstr += err.split(".")[1]+" : "+error.error.fieldErrors[0][err] + ",<br>";
                          }
                          this.alertCall('', errstr);
                        });

  }


  //Tax&Resale info API's
  async presentAlert() {
    const alert = await this.alertController.create({
    header: 'Attention',
    subHeader: 'You lost all your data, please regenerate the quote from plugin and come back',
    buttons: ['Dismiss']
   });
   await alert.present(); 
}
  getTaxData(){
    var headers = new  HttpHeaders()
                      .set("Content-Type", "application/json" )
                      .set("Accept", "application/json" )
                      .set("session", this.kicad_uuid);
                      // .set("Authorization", "bearer " + this.new_accessToken)

    this.httpClient.get<any>(this.AppBaseURL + "/taxTable", {headers:headers}
                      ).subscribe(data =>{
                        //console.log("TaxData",data);  

                        var taxData = new Array();
                        var taxInfo = data;
                        for(var i = 0; i < taxInfo.length; i++){
                          taxData.push({
                            rate    : taxInfo[i].rate,
                            city    : taxInfo[i].city,
                            country : taxInfo[i].country
                            })
                        }
                        //console.log('tax data is...................', taxData);
                        this.taxInformation = taxData;
                        //console.log("ndata", taxData);
                      }, error =>{
                        console.log('error found while get tax data', error);
                        this.presentAlert()
                      });
  }

  // getResaleData(){
  //   var headers = new  HttpHeaders().set("Authorization", "bearer "+this.new_accessToken)
  //                     .set("Content-Type", "application/json" )
  //                     .set("Accept", "application/json" );
  //   var params = {userID:this.kicad_uid}
  //   this.httpClient.get<any>(this.AppBaseURL + "/lastResale", {headers:headers, params:params}
  //                     ).subscribe(data =>{
  //                       //console.log("ResaleData",data);  

  //                       // var resaleData = new Array();
  //                       // var resaleInfo = data;
  //                       // console.log("resale", data);
  //                       // for(var i = 0; i < resaleInfo.length; i++){
  //                       //   resaleData.push({
  //                       //     resaleNumber    : resaleInfo[i].resaleNumber
  //                       //     })
  //                       // }
  //                       this.resaleInformation = data.resaleNumber;
  //                       console.log("ndata", this.resaleInformation);
  //                     }, error =>{
  //                       console.log('error found while get resale data', error);
  //                     });
  // }

  getReQuoteData(requoteData){
    var headers = new  HttpHeaders().set("Authorization", "Bearer "+this.kicad_accessToken)
                      .set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );

    return this.httpClient.post<any>(this.femsUrl + "/quote/standardpcb", requoteData, {headers:headers, params: {user_id: this.kicad_uid}});
  }

//   validateFileUpload(formData){
//     let precessedData: any = true;
//     let contentTypeData: any = true;
//     var imghttpOptions = {
//       headers: new HttpHeaders({
//         // 'Content-Type': 'multipart/form-data',
//         'processData': precessedData,
//         "contentType": contentTypeData,
//       })
//     }

//     return this.httpClient.post<any>("https://bcvstaging.app.protoexpress.com/bcv/validate-compare", formData, imghttpOptions);
//  }

  getBomUploadDataOld(url){
    return new Promise((resolve,reject)=>{ 
      var params = {
         AttributeNames: [
            "SentTimestamp"
         ],
         MaxNumberOfMessages: 10,
         MessageAttributeNames: [
            "All"
         ],
         QueueUrl: url,
         // QueueUrl: 'https://sqs.us-east-1.amazonaws.com/719945103823/'+url,
         WaitTimeSeconds: 20
      };
      var sqs = new AWS.SQS({apiVersion: '2012-11-05'});
      if(this.initialPrecheck){
      sqs.receiveMessage(params,(err: any, response: any)=>{
        if (response.Messages.length>0) {
          for(var msgsqs of response.Messages){
          // console.log(JSON.parse(msgsqs.Body)['bom_item_id'])
              // var params = {
              //   MessageBody: msgsqs.Body,
              //   QueueUrl: url,
              //   DelaySeconds: 10
              // };
              // sqs.sendMessage(params, function(err, data) {
              //   if(err) {
              //       // console.log(err);
              //       // reject(err)
              //   }
              //   else {
              //       // console.log(data);
              //       // resolve(JSON.parse(response.Messages[0].Body))
              //   }
              // });

              const deleteParams = {
                QueueUrl: url,
                ReceiptHandle: msgsqs.ReceiptHandle
              };
              sqs.deleteMessage(deleteParams, (err, data) => {
                if (err) {
                  // console.log(err, err.stack);
                } else {
                  // console.log('Successfully deleted message from queue');
                }
              });
          }
          // this.getBomUploadData(url);
          // if(response.Messages[0].Body){
          //   if (JSON.parse(response.Messages[0].Body)) {
          //     response['route'] = 'SQS';
              resolve(response.Messages)
              // resolve(JSON.parse(response.Messages))
              reject(err)
          //   }else{
          //     var s3Bom = new AWS.S3({region: 'us-east-1'});

          //     s3Bom.getObject({Bucket: JSON.parse(response.Messages[0].Body)[1]['s3BucketName'],Key: JSON.parse(response.Messages[0].Body)[1]['s3Key']}).promise()
          //     .then((data)=>{
          //       data['route'] = 'S3';
          //       resolve(data.Body.toString('utf-8'))
          //       // reject(err)
          //     });
          //   }
          // };

        
   
        }else{
          this.hideLoader();
          // this.getBomUploadData(url);
          if (err) {
            reject(err);
          }
        }
        
      });

    }else{

              const deleteParams = {
                QueueUrl: url
              };
              sqs.purgeQueue(deleteParams, (err, data) => {
                this.initialPrecheck = true;
                if (err) {
                  // console.log(err, err.stack);
                } else {
                  // console.log('Successfully deleted message from queue');
                }
              });
    }
    
    });
  }

  getBomUploadData(bomId){
    return new Promise((resolve,reject)=>{ 
      var headers = new HttpHeaders()
      // .set("Authorization", "Bearer "+JSON.parse(localStorage.getItem('quoteData'))['accessToken'])
      .set("Authorization", "")
      .set("Content-Type", "application/json")
      return this.httpClient.get<any>( this.bomProcessUrl+"/bom/"+bomId+'/validation', {headers: headers}).subscribe(resData =>{
        return resolve(resData);
      },error=>{
        return resolve(error);
        console.log(error);
      })
    });
  }

  getsearchAssistData(reqSrchData){
    var headers = new  HttpHeaders().set("Authorization", "Bearer "+this.kicad_accessToken)
                      .set("Content-Type", "application/json" )
                      .set("Accept", "application/json" )
                      .set("internalQueueUrl", JSON.parse(localStorage.getItem('quoteData'))['BOMValSqsQueues'][1] );
                      
          return new Promise((resolve,reject)=>{
            this.httpClient.post<any>(this.bomProcessUrl + "/bom/parts/search", reqSrchData, {headers:headers}).subscribe(resData =>{
                return resolve(resData);
              },error=>{
                return resolve(error);
                console.log(error);
          })
    });
  }

  createBOM(bomData){
    let precessedData: any = true;
    let contentTypeData: any = true;
    var imghttpOptions = {
      headers: new HttpHeaders({
        // 'Content-Type': 'multipart/form-data',
        'processData': precessedData,
        "contentType": contentTypeData,
      })
    }

    return this.httpClient.post<any>(this.femsshipping + "/createAttachBOM", bomData, imghttpOptions);
  }

  customBOMUpload(bomMappingData){
    var headersobj = new HttpHeaders().set("Authorization", "Bearer "+JSON.parse(localStorage.getItem('quoteData'))['accessToken']).set("Content-Type", "application/json")
    .set("queueUrl", JSON.parse(localStorage.getItem('quoteData'))['BOMValSqsQueues'][0] )
    .set("internalQueueUrl", JSON.parse(localStorage.getItem('quoteData'))['BOMValSqsQueues'][1] );
    // return this.httpClient.post<any>(this.AppLocationBaseURL+"/bom", bomMappingData, {headers: headersobj})
    return this.httpClient.post<any>(this.bomProcessUrl+"/bom", bomMappingData, {headers: headersobj})
  }

  getBOMTable(bomId,hitType){
    var headers = new HttpHeaders()
    // .set("Authorization", "Bearer "+JSON.parse(localStorage.getItem('quoteData'))['accessToken'])
    .set("Authorization", "")
    .set("Content-Type", "application/json" )
    .set("queueUrl", hitType && hitType == 'delete' || hitType == 'pregenerated' ? '' : JSON.parse(localStorage.getItem('quoteData'))['BOMValSqsQueues'][0] )
    .set("internalQueueUrl", hitType && hitType == 'delete' || hitType == 'pregenerated' ? '' : JSON.parse(localStorage.getItem('quoteData'))['BOMValSqsQueues'][1] );
    
    return this.httpClient.get<any>( this.bomProcessUrl+"/bom/"+bomId, {headers: headers})
    // return this.httpClient.get<any>( this.AppLocationBaseURL+"/bom/"+bomId, {headers: headers})
  }

saveEditOrFixLineItemReq(lineItemData){
  var headers = new HttpHeaders().set("Authorization", "Bearer "+JSON.parse(localStorage.getItem('quoteData'))['accessToken']).set("Content-Type", "application/json; charset=utf-8" )
  .set("queueUrl", JSON.parse(localStorage.getItem('quoteData'))['BOMValSqsQueues'][0] ).set("internalQueueUrl", JSON.parse(localStorage.getItem('quoteData'))['BOMValSqsQueues'][1] );

  // return new Promise((resolve,reject)=>{  
  //   return this.httpClient.put<any>( this.AppLocationBaseURL + "/bom/"+lineItemData.bom_id+'/item/'+lineItemData.bom_item_id,lineItemData,{headers: headers}
  //         ).subscribe(data => {
  //           console.log('res')
  //         },error=>{
  //           console.log(error);
  //     });
  //   });
  lineItemData['internalQueueUrl'] = JSON.parse(localStorage.getItem('quoteData'))['BOMValSqsQueues'][1]
  lineItemData['queueUrl'] = JSON.parse(localStorage.getItem('quoteData'))['BOMValSqsQueues'][0]
  // return this.httpClient.put<any>( this.AppLocationBaseURL + "/bom/"+lineItemData.bom_id+'/item/'+lineItemData.bom_item_id,lineItemData,{headers: headers});  
  return this.httpClient.put<any>( this.bomProcessUrl + "/bom/"+lineItemData.bom_id+'/item/'+lineItemData.bom_item_id,lineItemData,{headers: headers});  
}

  saveEditDni(multiData,bomId){
    var headers = new HttpHeaders().set("Authorization", "Bearer "+JSON.parse(localStorage.getItem('quoteData'))['accessToken']).set("Content-Type", "application/json" );
    // var lineItemData ={};
    // lineItemData['internalQueueUrl'] = JSON.parse(localStorage.getItem('quoteData'))['BOMValSqsQueues'][1]
    // lineItemData['queueUrl'] = JSON.parse(localStorage.getItem('quoteData'))['BOMValSqsQueues'][0]
    return this.httpClient.put<any>( this.bomProcessUrl + "/bom/items/donotinstall/"+multiData,'',{headers: headers});  
    // return this.httpClient.put<any>( this.AppLocationBaseURL + "/bom/"+bomId+'/item/'+multiData,lineItemData,{headers: headers});  
  }
  deleteLineItemData(bomId,bomLineItemId){
    var headers = new HttpHeaders()
    .set("Authorization", "Bearer "+JSON.parse(localStorage.getItem('quoteData'))['accessToken'])
    .set("Content-Type", "application/json" )
    // .set("queueUrl", JSON.parse(localStorage.getItem('quoteData'))['BOMValSqsQueues'][0] ).set("internalQueueUrl", JSON.parse(localStorage.getItem('quoteData'))['BOMValSqsQueues'][1] );
      return this.httpClient.delete<any>( this.bomProcessUrl + "/bom/"+bomId+'/item/'+bomLineItemId,{headers: headers});
      // return this.httpClient.delete<any>( this.AppLocationBaseURL + "/bom/"+bomId+'/item/'+bomLineItemId,{headers: headers});
  }

  generateQuoteBOM(bomData){
    let processedData: any = true;
    let contentTypeData: any = true;
    var imghttpOptions = {
      headers: new HttpHeaders({
        // 'Content-Type': 'multipart/form-data',
        'processData': processedData,
        "contentType": contentTypeData,
      })
    }

    return this.httpClient.post<any>(this.femsshipping + "/createAttachBOMSCA", bomData, imghttpOptions);
  }

  generateAssemblesTT(assemblesURL,assemblesData){
    var headers = new HttpHeaders().set("Authorization", "Bearer "+JSON.parse(localStorage.getItem('quoteData'))['accessToken']).set("Content-Type", "application/json" )
    // .set("queueUrl", JSON.parse(localStorage.getItem('quoteData'))['BOMValSqsQueues'][0] ).set("internalQueueUrl", JSON.parse(localStorage.getItem('quoteData'))['BOMValSqsQueues'][1] );
    return this.httpClient.post<any>( this.femsUrl + "/quote/assembly?"+assemblesURL, assemblesData,{headers: headers});
  }

  addNewLineItemData(bomId,bomNewLineItem){
    var headersObj = new HttpHeaders().set("Authorization", "Bearer "+JSON.parse(localStorage.getItem('quoteData'))['accessToken'])
    .set("Content-Type", "application/json; charset=utf-8")
    .set("internalqueueurl", JSON.parse(localStorage.getItem('quoteData'))['BOMValSqsQueues'][1] )
    .set("queueurl", JSON.parse(localStorage.getItem('quoteData'))['BOMValSqsQueues'][0] );
      // return this.httpClient.post<any>(this.bomProcessUrl + "/bom/"+bomId+'/item', bomNewLineItem, {headers: headers})
      
      var options = { headers: headersObj};
    return new Promise((resolve,reject)=>{
      this.httpClient.post<any>( this.bomProcessUrl + "/bom/"+bomId+'/item', bomNewLineItem, options).subscribe((data)=>{
        resolve(data);
      },error=>{
        resolve(error);
        console.log(error);
      })
    })
      // return this.httpClient.post<any>(this.AppLocationBaseURL + "/bom/"+bomId+'/item', bomNewLineItem, {headers: headers})

  }

  getOrderInputDetails(){
    // if(this.isGuestGlobal == false || this.isGuestGlobal == "False"){
    //   var headers = new HttpHeaders().set("Authorization", "Bearer "+JSON.parse(localStorage.getItem('quoteData'))['accessToken']).set("Content-Type", "application/json" )
    // }else if(this.isGuestGlobal=="noGuestKey"){
    //   var headers = new HttpHeaders().set("Authorization", "Bearer "+JSON.parse(localStorage.getItem('quoteData'))['accessToken']).set("Content-Type", "application/json" )
    // }else{
    //   var headers = new HttpHeaders().set("Authorization", "Bearer "+this.loginAccessToken).set("Content-Type", "application/json" )
    // }
    //var headers = new HttpHeaders().set("Authorization", "Bearer "+JSON.parse(localStorage.getItem('quoteData'))['accessToken']).set("Content-Type", "application/json" )
                      // .set("internalQueueUrl", JSON.parse(localStorage.getItem('quoteData'))['BOMValSqsQueues'][0] );
    var headers = new HttpHeaders().set("session", this.kicad_uuid )
    var params = {user_id:this.kicad_uid};
    // return this.httpClient.get<any>( this.AppLocationBaseURL+"/quote/inputs", {headers: headers, params:params})
    this.httpClient.get<any>( this.AppBaseURL+"/quote_inputs"
                      , {headers: headers, params: params}
                      ).subscribe(data =>{
                        // var arrinputs = [];
                        this.kicad_pcbPartDataSpecs = [];
                        var qinput = {};
                        for(var k in data['products']){
                          for(var k1 in data['products'][k]['quoteInputGroups']){
                            for(var k2 in data['products'][k]['quoteInputGroups'][k1]['quoteInputs']){
                              // arrinputs.push({'iName': data['products'][k]['quoteInputGroups'][k1]['quoteInputs'][k2]['inputName'],'dName': data['products'][k]['quoteInputGroups'][k1]['quoteInputs'][k2]['displayName']})
                              if (qinput[data['products'][k]['quoteInputGroups'][k1]['quoteInputs'][k2]['inputName']] == undefined) {
                                qinput[data['products'][k]['quoteInputGroups'][k1]['quoteInputs'][k2]['inputName']] = [];
                                qinput[data['products'][k]['quoteInputGroups'][k1]['quoteInputs'][k2]['inputName']].push({'iName': data['products'][k]['quoteInputGroups'][k1]['quoteInputs'][k2]['inputName'],'dName': data['products'][k]['quoteInputGroups'][k1]['quoteInputs'][k2]['displayName']});
                              }
                            }
                          }
                        }
                        // console.log(JSON.stringify(arrinputs));
                        for(var t in this.partDataJson){
                          for(var qi in qinput){
                            for(var pd in qinput[qi]){
                              if (qinput[qi][pd]['iName'] == t) {
                                if(qinput[qi][pd]['dName'] == "Allow RoHS Marking"){
                                  this.partDataJson[t] = "No";
                                }
                                this.kicad_pcbPartDataSpecs.push({'dname': qinput[qi][pd]['dName'],'sname': t,'value': this.partDataJson[t]})
                                if(this.kicad_pcbPartDataSpecs.length == 1){
                                  this.kicad_pcbPartDataSpecs.push({'dname':'PCB turn-time','value':this.quoteItems[0].turntime + ' Day(s)'})
                                }
                              }
                            }
                          }
                        } 
                      },error=>{
                        console.log("getOrderInputDetails",error);
                      });
  }

  addressValidationCheck(){
    var headers = new HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
    let params = new HttpParams().set("address1", this.contact_address1)
                      .set("city", this.contact_city)
                      .set("state", this.state_list[this.contact_state])
                      .set("zip", this.contact_zipcode);
                      //console.log(this.contact_address1, this.contact_city,this.contact_state,this.contact_zipcode);
    // return this.httpClient.get<any>( this.AppLocationBaseURL+"/address-validation", {headers: headers, params:params})
    return new Promise((resolve,reject)=>{
      this.httpClient.get<any>( this.AppLocationBaseURL+"/address-validation", {headers: headers, params:params}).pipe(delay(2000)).subscribe((data)=>{
        resolve(data);
      },error=>{
                        resolve(error);
                        console.log(error);
                      })
    })
  }

  addNewAddressNew(addressId,address_data_body){
    // this.address_id = addressId;
    // this.address_type_id = addressId;
    // if(this.shippingAddressPopup){
    //   this.address_type_id = '3'
    // }
    // if (this.billingAddressPopup){
    //   this.address_type_id = '2'
    // }
    // if (this.designerAddressPopup){
    //   this.address_type_id = '1'
    // }
    // if(this.add_to_all_address){
    //   this.address_type_id = addressId;
    // }
    //console.log(this.address_type_id );
    var headersObj = new HttpHeaders().set("Content-Type", "application/json")
                                   .set("Accept", "application/json")
                                   .set("session", this.kicad_uuid);
                                  //  .set("Authorization", "Bearer "+ this.new_accessToken)
                                  //  .set("Cookie","JSESSIONID=95F3BE0B1A2CFCFE1DF5BFF1B549C03E");
    var paramsObj = {userID:this.kicad_uid}                               
    //let params = new HttpParams().set("userID", this.kicad_uid);
               
    var options = { headers: headersObj , params: paramsObj};

    
    console.log("addressbody", address_data_body);
    // return this.httpClient.post<any>( this.AppBaseURL + "/address" , address_data_body, options)
    // .pipe(delay(1000))
    return new Promise((resolve,reject)=>{
      this.httpClient.post<any>( this.AppBaseURL + "/address" , address_data_body, options).subscribe((data)=>{
        if(!data.msg || data.msg != 'Access denied'){
          resolve(data);
        }else{
          this.router.navigateByUrl('/session-timeout-model');
        }
      },error=>{
                        resolve(error);
                        console.log(error);
                      })
    })
  }

  updateNewAddressDetails(addressId){
    this.address_id = addressId;
    console.log("AD ID", addressId);
    var headers = new HttpHeaders()
                                  .set("Content-Type", "application/json" )
                                  .set("Accept", "application/json" )
                                  .set("session", this.kicad_uuid);
                                  // .set("Authorization" , "Bearer "+this.new_accessToken)

    var params = {userID:this.kicad_uid} 
    //this.address_type_id
    // var default_add = this.default_add_address == true ? "1":"0";
    var update_address_body = {
      // "addressType":this.address_type_id,
      "addressid":this.address_id, 
      "firstname":this.contact_first_name,
      "lastname":this.contact_last_name, 
      "email":this.contact_email, 
      "phone":this.contact_phone,
      "fax":this.contact_fax,
      "address1": this.contact_address1 , 
      "address2" : this.contact_address2,
      "city":this.contact_city ,
      "country":this.contact_country, 
      "state":this.contact_state,
      "zip":this.contact_zipcode,
      // "defaultForType":default_add,
      "company":this.contact_company,
      "isDefaultForShipping": this.address_type_id.join().indexOf('3')>-1? '1': '0',
      "isDefaultForBilling": this.address_type_id.join().indexOf('2')>-1? '1': '0',
      "isDefaultForDesign": this.address_type_id.join().indexOf('1')>-1? '1': '0'
    };
    console.log("update_address_body",update_address_body); 
    
    return this.httpClient.put<any>( this.AppBaseURL + "/address",update_address_body,{headers: headers, params:params })
  }

  getDisplayingAddress(){
    var address_type = '';
    if(this.shippingAddressPopup){
      address_type = '3'
    }
    if (this.billingAddressPopup){
      address_type = '2'
    }
    if (this.designerAddressPopup){
      address_type = '1'
    }
    var headers = new  HttpHeaders()
                      .set("Content-Type", "application/json" )
                      .set("Accept", "application/json" )
                      .set("session", this.kicad_uuid);
                      // .set("Authorization", "Bearer "+ this.new_accessToken)
    var params = {userID:this.kicad_uid}
    //let params = new HttpParams().set("userID", "00c82b43-6fb5-4e2f-9488-0d8c1c107a98");  
    return new Promise((resolve,reject)=>{
      this.httpClient.get<any>( this.AppBaseURL+"/address", {headers: headers, params: params}).subscribe(data => { 
        return resolve(data);
      }, error => {
        return resolve(error);
        console.log(error);
      });
    }) 
  }

  getWqNum(){
    if(this.wqNumForLog == '' || this.wqNumForLog == undefined){
      if(sessionStorage.getItem('wqId') == '' || sessionStorage.getItem('wqId') == undefined){
        var headers = new HttpHeaders().set("Content-Type", "application/json")
                                     .set("Accept", "application/json")
                                    //  .set("Authorization", "Bearer "+ this.new_accessToken);
                                    .set("session", this.kicad_uuid);
        var params = {userID:this.kicad_uid,wmqID:this.kicad_wmqid}
        var dataObj = {pcbQuantity:this.kicad_selectedQuantity, pcbTurntime:this.kicad_selectedTurntime,assemblyQuantity:this.assemblyQty?this.assemblyQty:null,assemblyTurntime:this.assemblyTurnTime?this.assemblyTurnTime:null};
          return this.httpClient.post<any>( this.AppBaseURL + "/createwebquote",dataObj,{headers: headers, params: params}).subscribe(data => {
            if(!data.msg || data.msg != 'Access denied'){
              console.log(data);
              this.wqNumForLog = data.wqID;
              sessionStorage.setItem('wqId','');
              sessionStorage.setItem('wqId',data.wqID);
            }else{
              this.router.navigateByUrl('/session-timeout-model');
            }
          },error=>{
            console.log(error);
          });
      }else{
        this.wqNumForLog = sessionStorage.getItem('wqId');
      }
    }
  }
  clientIdAut(){
    var headers = new HttpHeaders().set("Content-Type", "application/json")
                                  .set("Accept", "application/json")
                                  .set("Authorization", "Basic "+ this.clientID);
    var dataObj = {
      "client_id"   :this.clientID, 
    };
    return this.httpClient.post<any>( this.femsUrl + "/client",dataObj,{headers: headers}).subscribe(data => {
      console.log("clientID auth",data)
    },error=>{
      console.log(error);
    });
  }
  logInUser(loginData){
    console.log("loginData",loginData);
    var headers = new  HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json")
                      .set("session", this.kicad_uuid);
  // const formData = new FormData();
  // const dataJson = loginData;
  // //console.log('dataJson:', dataJson);
  // formData.append('loginOrRegister', JSON.stringify(dataJson));
  // console.log('formData: ', formData.getAll('loginOrRegister'));
    var params = {userID:this.kicad_uid,wqnumber:this.wqNumForLog,client_id:this.clientID}
    return this.httpClient.post<any>(this.femsshipping +'/syncGuestToMid', loginData, {headers:headers,params: params});
  }
  registerUser(registerDataObj){
    console.log("loginData",registerDataObj);
    var headers = new  HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" )
                      .set("session", this.kicad_uuid);
  const dataJson = registerDataObj;
    var params = {client_id:this.clientID}
    return this.httpClient.post(this.femsshipping +'/register', dataJson, {headers:headers,params: params});
  }
  
  forgotPassword(mail){
    var headers = new HttpHeaders().set("Content-Type", "application/json")
                                  .set("Accept", "application/json")
                                  .set("session", this.kicad_uuid);
                                  // .set("Authorization", "Basic "+ this.clientID);
    var dataObj = {
      // client_id:this.clientID, 
      username:mail,
      last_name:''
    };
    return new Promise((resolve,reject)=>{ 
      this.httpClient.post<any>( this.AppBaseURL + "/recover_password",dataObj,{headers: headers}).subscribe(data => {
        return resolve(data);
      },error=>{
        return resolve(error);
      });
    });
  }

  updatePassword(pwd){
    this.showLoader();
    var headers = new HttpHeaders().set("Content-Type", "application/json")
                                  .set("Accept", "application/json")
                                  .set("session", this.kicad_uuid);
                                  // .set("Authorization", "Bearer "+ this.loginAccessToken);
    var dataObj = {
      user_id:this.kicad_uid, 
      // old:"null",
      new:pwd
    };
    return new Promise((resolve,reject)=>{
      this.httpClient.put<any>(this.AppBaseURL+"/update_password",dataObj,{headers: headers}).subscribe(data => {
        this.hideLoader();
        return resolve(data);
      },error=>{
        this.hideLoader();
        return resolve(error);
      });
    });
  }
  //quoteItems
  quoteDeatils(){
    var headers = new HttpHeaders().set("Content-Type", "application/json")
                                     .set("Accept", "application/json")
                                     .set("session", this.kicad_uuid);
                                    //  .set("Authorization", "Bearer "+ this.new_accessToken);
    var params = {userID:this.kicad_uid,wqID:this.wqNumForLog}
      return this.httpClient.get<any>( this.AppBaseURL + "/getquotedetails",{headers: headers, params: params});
  }
  //partData
  savedPcbPartData(){
    var headers = new HttpHeaders().set("Content-Type", "application/json")
                                     .set("Accept", "application/json")
                                     .set("session", this.kicad_uuid);
                                    //  .set("Authorization", "Bearer "+ this.new_accessToken);
    var params = {userID:this.kicad_uid,wmqID:this.kicad_wmqid}
    return new Promise((resolve,reject)=>{ 
      this.httpClient.get<any>( this.AppBaseURL + "/getsavedpcbpartdata",{headers: headers, params: params}).subscribe(data => {
        console.log(data);
        this.loginOrderData['partdata'] = data;
        console.log

        if ('partdata' in this.loginOrderData){
          this.partData = JSON.stringify(this.loginOrderData['partdata']).slice(1, -1).replace(/"/g, ' ').replace(/,/g, ', ');
          this.partDataJson = this.loginOrderData['partdata'];
          this.quoteItems = this.loginOrderData['quoteItems']
          this.wqId = this.loginOrderData['wqID']
          this.projectID = this.loginOrderData['projectID']
          // this.getOrderDetails()
          this.getOrderInputDetails();
          // this.getShippingOptions('');
        }
        return resolve(data);
      },error=>{
        return resolve(error);
        console.log(error);
      });
    });
  }

  accessTokenLogin(loginObj){
    var headers = new  HttpHeaders().set("Content-Type", "application/json" )
                                    .set('Accept','application/json')
                                    // .set('Authorization','Basic b0bbbed0-f5b2-11eb-8ef3-3f8a2a71f67e')
    var options = { headers: headers};
    const body = {
      "client_id": "d9cbe43a-dbcd-11ea-87d0-0242ac130003",
      "memberID": loginObj.memberID,
      "password": loginObj.password
    }
    return new Promise((resolve,reject)=>{
      this.httpClient.post<any>(this.AppBaseURL + '/login', body, options).subscribe(data => {
        return resolve(data);
      }),error=>{
        return resolve(error);
        console.log(error);
      };
    });
  }

  verifyCode(verifyObj){
    var headers = new  HttpHeaders().set("Content-Type", "application/json")
                      .set("Accept", "application/json" );
    var params = {userID:this.kicad_uid}
    return this.httpClient.post(this.femsshipping +'/verifyOtp', verifyObj, {headers: headers, params: params});
  }
  
  resendCode(){
    var headers = new  HttpHeaders().set("Content-Type", "application/json")
                      .set("Accept", "application/json" );
    var params = {userID:this.kicad_uid,isOtpForLogin:'true'}
    return this.httpClient.get(this.femsshipping +'/generateOrResendOtp', {headers: headers, params: params});
  }

  gotoOrder(){
    var headers = new  HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
    let params = new HttpParams().set("userID", this.kicad_uid)
                                 .set("orderNumber", this.femsTrueSubmit.orderNumber);
    this.httpClient.get<any>(this.bomProcessUrl+ "/order/redirectUrl", {headers:headers, params:params}).subscribe(data =>{
      console.log("URL REDIRECT",data);
    var responseData = data;
      this.orderRedirectUrl = responseData.redirectUrl;
      //window.open(responseData.redirectUrl, '_blank');
    }, error =>{
        console.log('Error in tracking your order', error);
        //this.presentAlert()
    });
  }

  promoDeatils(promocode:any){
    var headers = new  HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
                      //.set("Authorization","Bearer 5f1708cc-7c5c-11ee-aa29-92a471baf889");
    let params = new HttpParams().set("userID", this.kicad_uid)
                                  //.set("memberId",this.commonService.commonMainObj.userSessionMemberId ? this.commonService.commonMainObj.userSessionMemberId : null)
                                  .set("promoCode", promocode)
                                  .set("webQuoteNumber", this.wqId);
    return this.httpClient.get<any>( this.AppBaseURL+"/fetchPromoCodeAppliedToOrderInfo",{headers: headers, params:params })
  }
  getPendingPaymentMessage(orderNumber:any){
  var headers = new HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
  var params = {userID:this.kicad_uid,orderNumber:(orderNumber).split("-")[0]}
    return this.httpClient.get(this.AppBaseURL + '/getPendingPaymentMessage',{headers: headers, params:params});
 }

}
